import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // ─── NAVBAR & COMMON ───
      navHome: "Home",
      navAbout: "About Us",
      navProducts: "Products",
      navServices: "Services",
      navBlog: "Blog",
      navFAQ: "FAQ",
      navContact: "Contact",
      navCallNow: "Call Now",
      navLanguage: "LANGUAGE",
      navContactLabel: "Contact",

      // ─── HERO SLIDES & CONTROLS ───
      heroBadge1: "ENGINEERED. TRUSTED. PROVEN.",
      heroBadge2: "QUALITY. PERFORMANCE. INNOVATION.",
      heroBadge3: "TRUSTED. DURABLE. EFFICIENT.",
      heroTitle1_1: "Precision Agricultural",
      heroTitle1_2: "Processing Solutions",
      heroDesc1: "Advanced machinery for raisin, dry fruit, and food processing—built to improve productivity, efficiency, and consistent processing quality.",
      heroTitle2_1: "Revolutionizing",
      heroTitle2_2: "Agricultural Machinery",
      heroDesc2: "From Bedana Processing Machines to Air Classifiers and Conveyors, we deliver reliable equipment engineered for modern processing industries.",
      heroTitle3_1: "Engineering",
      heroTitle3_2: "Industrial Excellence",
      heroDesc3: "Providing reliable agricultural and food processing machinery with dependable support for businesses across India and international markets.",
      btnExploreProducts: "Explore Products",
      btnContactSales: "Contact Sales",
      heroBadgeNationsTitle: "3+ Nations",
      heroBadgeNationsDesc: "Global Export",
      heroBadgeYieldTitle: "High Yield",
      heroBadgeYieldDesc: "Agri Processing",
      heroBadgeZeroMaintTitle: "Zero Maint",
      heroBadgeZeroMaintDesc: "Durable Design",
      heroBadgeFastDeliveryTitle: "Fast Delivery",
      heroBadgeFastDeliveryDesc: "Global Logistics",
      heroBadgeSupportTitle: "24/7 Support",
      heroBadgeSupportDesc: "Client Success",

      // ─── MARQUEE ───
      mq1: "Trusted by 5000+ Farmers",
      mq2: "Zero Maintenance Technology",
      mq4: "Exported to 3+ Countries",
      mq5: "35+ Years of Excellence",
      mq6: "India's Leading Agro Machinery",

      // ─── STATS ───
      stat1Label: "Years of Engineering Excellence",
      stat2Label: "Machines Installed",
      stat3Label: "Countries Exported",
      stat4Label: "Support",

      // ─── HOME INTRO ───
      introTitle: "Welcome to",
      introLead: "Digvijay Industries is a trusted manufacturer of agricultural and food processing machinery, delivering reliable solutions designed for efficiency, precision, and long-lasting performance.",
      introDesc: "From raisin processing and pomegranate machinery to conveyor systems and custom equipment, we help farmers, food processors, and agro industries improve productivity with advanced engineering.",
      feature1: "Precision Engineered Machines",
      feature2: "Premium Quality Manufacturing",
      feature3: "Reliable Service & Support",
      feature4: "Custom Industrial Solutions",
      btnExploreStory: "Explore Our Story",
      videoCaption: "Watch our High-Performance Raisin Processing Machine in Action",
      introBadgeSince: "Since 1989",
      introBadgeLegacy: "35+ Years Legacy",

      // ─── COMMITMENT / PROMISES ───
      commitTitle: "Our Commitment to",
      commitTitleHighlight: "Quality",
      why1Title: "Superior Quality",
      why1Desc: "Every machine is built with carefully selected materials and tested to deliver reliable performance for agricultural and food processing industries.",
      why2Title: "High Efficiency",
      why2Desc: "Our innovative machinery is designed to improve productivity, reduce manual effort, and ensure smooth day-to-day operations.",
      why3Title: "Dedicated Support",
      why3Desc: "We provide dependable technical assistance and customer support to help your business operate with confidence.",

      // ─── PROCESS / HOW IT WORKS ───
      processTitle: "From Design to",
      processTitleHighlight: "Delivery",
      step1Title: "Requirement Analysis",
      step1Desc: "We understand your processing requirements before recommending the right machinery solution.",
      step2Title: "Custom Engineering",
      step2Desc: "Our engineering team designs practical and efficient machines tailored to your production needs.",
      step3Title: "Precision Manufacturing",
      step3Desc: "Each machine is manufactured with quality craftsmanship to ensure durability and consistent performance.",
      step4Title: "Installation & Support",
      step4Desc: "We assist with installation, machine guidance, and ongoing support for smooth operations.",

      // ─── HOME SERVICES HIGHLIGHT ───
      servicesTitle: "Comprehensive",
      servicesTitleHighlight: "Engineering Services",
      btnAllServices: "All Services",

      // ─── HOME TESTIMONIALS ───
      testiTitle: "What Our",
      testiTitleHighlight: "Clients Say",

      // ─── WHY CHOOSE US ───
      whyChooseTitle: "Why Choose",
      whyChooseTitleHighlight: "Digvijay Industries?",
      wc1Title: "Trusted Expertise",
      wc1Desc: "Delivering dependable machinery solutions with strong engineering knowledge and industry experience.",
      wc2Title: "Reliable Performance",
      wc2Desc: "Machines built for smooth operation, consistent output, and long-term productivity.",
      wc3Title: "Global Quality",
      wc3Desc: "Manufactured using quality standards suitable for domestic and international industries.",
      wc4Title: "Customer Support",
      wc4Desc: "Dedicated assistance to ensure efficient machine operation and customer satisfaction.",
      wc5Title: "In-House Manufacturing",
      wc5Desc: "Designed and manufactured under one roof to maintain quality, precision, and consistency.",
      wc6Title: "Better Productivity",
      wc6Desc: "Engineered to help businesses improve efficiency while reducing operational effort.",

      // ─── HOME CTA ───
      ctaTitle: "Looking for the Right Agricultural Processing Machine?",
      ctaDesc: "Talk to our engineering experts for reliable agricultural and food processing machinery tailored to your production requirements.",
      btnCallExperts: "Call Our Experts",

      // ─── ABOUT PAGE ───
      aboutHeroBadge: "Since 1989",
      aboutHeroTitle1: "About",
      aboutHeroTitle2: "Us",
      aboutHeroDesc: "Since 1989, Digvijay Industries has been manufacturing advanced agricultural and food processing machinery, delivering precision-engineered solutions trusted by farmers, merchants, cold storages, food processors, and agro industries.",
      aboutStoryTag: "Our Story",
      aboutStoryTitle1: "Engineering Excellence for",
      aboutStoryTitle2: "Modern Agriculture",
      aboutStoryLead: "Digvijay Industries designs and manufactures advanced agricultural and food processing machinery that helps farmers, merchants, cold storages, food processors, and agro industries improve efficiency, productivity, and product quality.",
      aboutStoryP2: "From raisin processing and pomegranate machinery to conveyor systems and custom automation solutions, every machine is engineered with precision, durability, and dependable performance.",
      aboutStoryP3: "As trailblazers in raisin (Bedana) processing machinery, we have set the benchmark for quality and innovation across India and 12+ global markets.",
      aboutCheck1: "Agricultural Machinery Experts",
      aboutCheck2: "Food Processing Solutions",
      aboutCheck3: "Customer-Focused Engineering",
      aboutCheck4: "Reliable Manufacturing",
      aboutEst: "Est. 1989",
      aboutLegacy: "35+ Years Legacy",
      aboutFounderTag: "Meet the Founder",
      aboutFounderTitle: "The Leadership Behind Digvijay Industries",
      aboutFounderQuote: "\"At Digvijay Industries, our vision has always been to build innovative agricultural and food processing machinery that helps farmers, food processors, and industries achieve greater efficiency, productivity, and sustainable growth.\"",
      aboutFounderBio: "Since 1989, Digvijay Industries has been committed to manufacturing reliable agricultural and food processing machinery with precision engineering, quality craftsmanship, and customer-focused innovation. Every machine reflects our dedication to performance, durability, and long-term value.",
      aboutFounderBadge: "Manufacturing Excellence Since 1989",
      aboutAchieve1: "Agricultural Machinery Specialists",
      aboutAchieve2: "Food Processing Solutions",
      aboutAchieve3: "Precision Engineering Excellence",
      aboutAchieve4: "Customer-Focused Innovation",
      aboutVmTag: "What We Stand For",
      aboutVmTitle: "Vision & Mission",
      aboutVisionTitle: "Our Vision",
      aboutVisionDesc: "To become a trusted global manufacturer of agricultural and food processing machinery through innovation, quality engineering, and sustainable manufacturing.",
      aboutVision1: "Deliver innovative agricultural machinery solutions",
      aboutVision2: "Empower farmers and food processing industries",
      aboutVision3: "Manufacture reliable, high-performance machines",
      aboutVision4: "Expand with quality, innovation, and customer trust",
      aboutMissionTitle: "Our Mission",
      aboutMissionDesc: "To design reliable machinery that improves productivity, reduces operational effort, and delivers long-term value through continuous innovation and customer support.",
      aboutMission1: "Build precision-engineered processing machinery",
      aboutMission2: "Deliver dependable quality and technical support",
      aboutMission3: "Develop efficient and customized machine solutions",
      aboutMission4: "Ensure long-term customer satisfaction",
      aboutValuesTag: "Guiding Principles",
      aboutValuesTitle: "Our Core Values",
      valIntegrity: "Integrity",
      valIntegrityDesc: "We build trust through honesty, quality craftsmanship, and responsible business practices.",
      valInnovation: "Innovation",
      valInnovationDesc: "We continuously improve our machinery with practical engineering and advanced manufacturing.",
      valCustomerFirst: "Customer First",
      valCustomerFirstDesc: "Every solution is designed around customer requirements and long-term satisfaction.",
      valQuality: "Quality Excellence",
      valQualityDesc: "Every machine undergoes strict quality checks before reaching our customers.",
      valExpertise: "Engineering Expertise",
      valExpertiseDesc: "Our experienced team develops dependable machinery for modern agriculture and food processing.",
      valGrowth: "Sustainable Growth",
      valGrowthDesc: "We create efficient machinery that supports productivity while promoting responsible manufacturing.",
      aboutInfraTag: "Our Facility",
      aboutInfraTitle1: "Advanced Manufacturing",
      aboutInfraTitle2: "Infrastructure",
      aboutInfraP1: "Our modern manufacturing facility is equipped with advanced fabrication, machining, assembly, and quality inspection systems to deliver reliable agricultural machinery.",
      aboutInfraP2: "Every production stage is carefully managed by skilled professionals to ensure precision engineering, consistent quality, and dependable machine performance.",
      aboutInfraStat1Title: "Advanced Manufacturing",
      aboutInfraStat1Sub: "Precision Engineering",
      aboutInfraStat2Title: "Quality Inspection",
      aboutInfraStat2Sub: "Reliable Performance",
      aboutInfraStat3Title: "Customer Support",
      aboutInfraStat3Sub: "Complete Assistance",

      // ─── PRODUCTS PAGE ───
      productsBadge: "Our Range",
      productsTitle1: "Our",
      productsTitle2: "Products",
      productsSubtitle: "Precision-built agricultural and food processing machinery for efficient operations.",
      catAll: "All",
      catBedana: "Bedana Processing",
      catWashing: "Washing & Cleaning",
      catGrading: "Grading & Sorting",
      catConveyor: "Conveyor & Handling",
      catCustom: "Custom Equipment",
      catFoodProcessing: "Food Processing",
      catIndustrial: "Industrial Equipment",
      catAgri: "Agricultural Machinery",
      prodCapacity: "Capacity:",
      btnViewDetail: "View Detail",
      noProductsFound: "No products found in this category.",
      loadingText: "Loading...",

      // ─── PRODUCT DETAIL PAGE ───
      bcHome: "Home",
      bcProducts: "Products",
      bcAllProducts: "All Products",
      zoomHint: "Click to Full View & Zoom",
      pdKeyFeatures: "Key Features",
      pdProductOverview: "Product Overview",
      pdDetailedSpecs: "Detailed Specifications",
      pdBtnEnquire: "Enquire Now",
      pdBtnWhatsApp: "Quick Chat on WhatsApp",
      pdQuoteBadge: "Direct Factory Consultation",
      pdQuoteTitle: "Request Consultation & Quotation",
      pdQuoteDesc: "Interested in this machine? Fill in your details below for technical consultation, custom machinery configurations, and factory pricing.",
      pdQuoteSpecificDesc: "Interested in {{name}}? Fill in your details below for technical consultation, custom machinery configurations, and factory pricing.",
      pdBedanaOverview: "The {{name}} is specially designed for large-scale raisin processing with high productivity and reliable industrial performance. It delivers continuous operation while maintaining consistent product quality. Built for heavy-duty applications, it is ideal for commercial food processing industries.",
      pdBedanaShortDesc: "Advanced machinery for high-capacity raisin (Bedana) cleaning, washing, and processing with consistent quality.",
      pdBedanaSpec1: "The {{name}} by Digvijay Industries is engineered to meet the growing demands of commercial raisin manufacturing and dry fruit processing industries. Built with heavy-duty industrial fabrication, the machine offers high processing efficiency, consistent production quality, and reliable long-term performance. Its robust design allows continuous operation while reducing manual labour and improving overall production output.",
      pdBedanaSpec2: "Manufactured using premium engineering standards, this machine ensures smooth processing, low maintenance, and energy-efficient performance, making it an excellent investment for modern food processing facilities.",
      pdBedanaSpec3: "The machine features heavy-duty construction, high processing capacity, continuous production system, reliable industrial performance, easy maintenance, energy-efficient operation, user-friendly controls, durable fabrication, and long operational life.",
      pdBedanaSpec4: "It is suitable for raisin manufacturing plants, dry fruit processing industries, food processing companies, agricultural processing units, commercial packaging plants, and export-oriented food industries requiring large-scale production.",
      pdGeneralOverview: "The {{name}} is specially engineered for industrial agricultural and food processing with high productivity, precision performance, and long operational lifespan.",
      pdGeneralSpec1: "The {{name}} by Digvijay Industries is engineered to meet industrial grade standards, offering high processing efficiency and durable construction.",
      pdGeneralSpec2: "Manufactured using premium engineering standards, this machine ensures smooth processing, low maintenance, and energy-efficient performance for modern industrial facilities.",
      pdGeneralSpec3: "Built with robust materials, user-friendly controls, and dependable safety mechanisms to support rigorous daily plant workloads.",
      pdNotFoundTitle: "Product Not Found",
      pdNotFoundDesc: "The machinery you are looking for is either updated or unavailable.",
      pdBackToCatalog: "Back to Products Catalog",
      featCustomSolutions: "Custom Industrial Solutions",
      featStainlessSteel: "Manufactured in SS304 Stainless Steel & M.S.",
      featHeavyDuty: "Heavy-Duty Industrial Construction",
      featHighPerf: "High Performance & Continuous Production",
      featEnergySaving: "Energy Saving & Cost-Effective Operation",
      featLowMaint: "Low Maintenance & Long Operational Life",
      formPhonePlaceholder: "e.g. 9876543210",
      formEmailPlaceholder: "Enter your email address",

      // ─── SERVICES PAGE ───
      servicesBadge: "What We Offer",
      servicesTitle1: "Our",
      servicesTitle2: "Services",
      servicesSubtitle: "From installation and commissioning to maintenance, technical support, and custom engineering, we ensure reliable performance throughout your machine's lifecycle.",
      svcInstallTitle: "Installation & Commissioning",
      svcInstallDesc: "Expert on-site installation, trial runs, and machine tuning to ensure smooth startup and seamless workflow integration.",
      svcMaintTitle: "Preventive Maintenance",
      svcMaintDesc: "Scheduled health checks and scheduled servicing to eliminate downtime and maximize machine lifespan.",
      svcPartsTitle: "Genuine Spare Parts",
      svcPartsDesc: "Quick dispatch of precision-crafted authentic components to ensure uninterrupted plant operation.",
      svcTrainingTitle: "Operator Training",
      svcTrainingDesc: "Comprehensive operational and safety training for your facility staff to maximize output and efficiency.",
      svcCustomTitle: "Custom Engineering",
      svcCustomDesc: "Bespoke modifications and conveyor engineering tailored to your facility dimensions and production targets.",
      svcSupportTitle: "24/7 Technical Support",
      svcSupportDesc: "Prompt phone, video, and on-site engineering assistance to resolve technical issues swiftly.",
      svcConveyorTitle: "Conveyor & Material Handling Solutions",
      svcConveyorDesc: "Customized conveyor and material handling solutions for seamless movement of raw materials and finished products.",
      svcExportTitle: "Export & Logistics Solutions",
      svcExportDesc: "Reliable export and logistics support for agricultural and food processing machinery, including secure packaging, transit documentation, and timely delivery.",
      svcConsultTitle: "Technical Consultation & Project Support",
      svcConsultDesc: "Professional guidance to understand processing requirements, recommend optimal machinery solutions, and plan efficient production layouts.",
      catMaterialHandling: "Material Handling",
      catAirHandling: "Air Handling",
      catHeatingSystems: "Heating Systems",

      // ─── CONTACT PAGE ───
      contactBadge: "Get In Touch",
      contactTitle1: "Contact",
      contactTitle2: "Digvijay Industries",
      contactSubtitle: "Connect with our experts for agricultural and food processing machinery, product inquiries, custom machine solutions, technical support, or business partnerships.",
      contactDirectComm: "Direct Communication",
      contactInfoTitle: "Contact Information",
      contactInfoSubtitle: "Connect with our team for machinery inquiries, custom processing solutions, or technical support.",
      contactAddressLabel: "Factory & Office Address",
      contactPhoneLabel: "Phone Support",
      contactEmailLabel: "Email Address",
      tabGeneralInquiry: "General Inquiry",
      tabCareerApp: "Career Application",
      formFullName: "Full Name",
      formEnterFullName: "Enter your full name",
      formEmail: "Email Address",
      formPhone: "Phone Number",
      formEnterPhone: "Enter your phone number",
      formMessage: "Message",
      formMessagePlaceholder: "Write your inquiry or machinery requirement...",
      formSendMessage: "Send Message",
      formSending: "Sending...",
      formMsgSuccess: "Message sent successfully!",
      formPosition: "Position Applying For",
      formSelectPosition: "Select Position",
      posMechEng: "Mechanical Engineer",
      posTech: "Technician",
      posSales: "Sales Executive",
      posOther: "Other",
      formExperience: "Years of Experience",
      formUploadResume: "Upload Resume (PDF/DOC, max 700KB)",
      formSubmitApp: "Submit Application",
      formSubmitting: "Submitting...",
      formAppSuccess: "Application submitted successfully!",
      contactMapTitle: "Find Us on the Map",
      alertMissingTitle: "Missing Details",
      alertMissingText: "Please provide at least your Name and Phone Number.",
      alertSuccessTitle: "Request Sent Successfully!",
      alertSuccessText: "Thank you for your interest. Our technical team will contact you shortly.",
      alertErrorTitle: "Submission Failed",
      alertErrorText: "Something went wrong. Please reach out to us via WhatsApp or Phone.",

      // ─── FAQ PAGE ───
      faqBadge: "Help Center",
      faqTitle1: "Frequently Asked",
      faqTitle2: "Questions",
      faqSubtitle: "Find answers to common questions about our products, services, and company policies.",
      faqNoFaqs: "No FAQs found for this category.",
      faqStillQuestions: "Still have questions?",
      faqStillQuestionsDesc: "Can't find the answer you're looking for? Please reach out to our team directly.",
      faqContactBtn: "Contact Us",
      faqQ1: "What is the processing capacity of the Bedana Processing Machine?",
      faqA1: "Our Bedana Processing Machine delivers high capacity ranging from 1 ton up to 4 tons per hour, tailored for continuous commercial operation with minimum manual labour.",
      faqQ2: "What materials are used to construct the machinery?",
      faqA2: "All contact parts and heavy-duty structures are manufactured using premium food-grade SS304 stainless steel and high-tensile mild steel for maximum durability and hygiene.",
      faqQ3: "Do you provide on-site installation and operator training?",
      faqA3: "Yes, our experienced technical engineering team provides full on-site installation, trial run commissioning, and comprehensive operational training for your staff.",
      faqQ4: "Do you deliver and export machinery outside India?",
      faqA4: "Yes, Digvijay Industries has exported agricultural and food processing machinery to over 12 countries worldwide, with full export packaging and transit insurance.",

      // ─── BLOGS & BLOG POST PAGE ───
      blogsBadge: "Industry Insights",
      blogsTitle1: "Our",
      blogsTitle2: "Blogs",
      blogsSubtitle: "Explore expert insights on agricultural machinery, food processing technology, industry trends, machine maintenance, and engineering innovations from Digvijay Industries.",
      searchArticles: "Search articles...",
      noArticlesFound: "No articles found.",
      tryDifferentSearch: "Try a different search term or category.",
      readArticle: "Read Article",
      backToAllArticles: "Back to All Articles",
      backToBlogs: "Back to Blogs",
      blogNotFound: "Blog post not found.",

      // ─── FOOTER ───
      footerAboutDesc: "For over three decades, Digvijay Industries has been designing and manufacturing high-performance agricultural and food processing machinery engineered for durability, efficiency, and trusted quality.",
      footerQuickLinks: "Quick Links",
      footerContactInfo: "Contact Info",
      footerOpeningHours: "Opening Hours",
      footerMonSat: "Mon - Sat:",
      footerTime: "09.00 AM to 06.00 PM",
      footerWeeklyOff: "Weekly Off: Tuesday",
      footerRights: "All Rights Reserved.",
      footerDesignedBy: "Designed & Developed By"
    }
  },
  mr: {
    translation: {
      // ─── NAVBAR & COMMON ───
      navHome: "Home",
      navAbout: "आमच्याबद्दल",
      navProducts: "उत्पादने",
      navServices: "सेवा",
      navBlog: "ब्लॉग",
      navFAQ: "प्रश्नोत्तरे (FAQ)",
      navContact: "संपर्क",
      navCallNow: "आत्ताच कॉल करा",
      navLanguage: "भाषा",
      navContactLabel: "संपर्क",

      // ─── HERO SLIDES & CONTROLS ───
      heroBadge1: "इंजिनिअर केलेले. विश्वासार्ह. सिद्ध केलेले.",
      heroBadge2: "गुणवत्ता. अचूक कामगिरी. नाविन्यता.",
      heroBadge3: "विश्वासार्ह. टिकाऊ. कार्यक्षम.",
      heroTitle1_1: "अचूक कृषी",
      heroTitle1_2: "प्रक्रिया उपाय",
      heroDesc1: "बेदाणा, ड्राय फ्रूट आणि अन्न प्रक्रियेसाठी अत्याधुनिक मशिनरी—उत्पादकता, कार्यक्षमता आणि गुणवत्ता वाढवण्यासाठी निर्मित.",
      heroTitle2_1: "कृषी मशिनरीमध्ये",
      heroTitle2_2: "क्रांतिकारी बदल",
      heroDesc2: "बेदाणा प्रक्रिया मशीनपासून ते एअर क्लासिफायर आणि कन्व्हेयरपर्यंत, आधुनिक प्रक्रिया उद्योगांसाठी आम्ही विश्वासार्ह उपकरणे देतो.",
      heroTitle3_1: "औद्योगिक",
      heroTitle3_2: "उत्कृष्टतेची निर्मिती",
      heroDesc3: "भारत आणि आंतरराष्ट्रीय बाजारातील उद्योगांसाठी उत्तम सपोर्टसह विश्वासार्ह कृषी आणि अन्न प्रक्रिया मशिनरी.",
      btnExploreProducts: "उत्पादने पहा",
      btnContactSales: "संपर्क साधा",
      heroBadgeIsoTitle: "ISO प्रमाणित",
      heroBadgeIsoDesc: "गुणवत्ता खात्री",
      heroBadgeNationsTitle: "3+ देश",
      heroBadgeNationsDesc: "जागतिक निर्यात",
      heroBadgeYieldTitle: "भरघोस उत्पादन",
      heroBadgeYieldDesc: "कृषी प्रक्रिया",
      heroBadgeZeroMaintTitle: "झिरो मेंटेनन्स",
      heroBadgeZeroMaintDesc: "टिकाऊ डिझाइन",
      heroBadgeFastDeliveryTitle: "जलद डिलिव्हरी",
      heroBadgeFastDeliveryDesc: "ग्लोबल लॉजिस्टिक्स",
      heroBadgeSupportTitle: "२४/७ सपोर्ट",
      heroBadgeSupportDesc: "ग्राहक यश",

      // ─── MARQUEE ───
      mq1: "५०००+ शेतकऱ्यांचा विश्वास",
      mq2: "झिरो मेंटेनन्स तंत्रज्ञान",

      mq4: "3+ देशांमध्ये निर्यात",
      mq5: "३५+ वर्षांचा अनुभव",
      mq6: "भारतातील अग्रगण्य ॲग्रो मशिनरी",

      // ─── STATS ───
      stat1Label: "इंजिनिअरिंग उत्कृष्टतेची वर्षे",
      stat2Label: "बसविलेली मशीन्स",
      stat3Label: "निर्यात केलेले देश",
      stat4Label: "सतत सपोर्ट",

      // ─── HOME INTRO ───
      introTitle: "मध्ये आपले स्वागत आहे",
      introLead: "दिग्विजय इंडस्ट्रीज ही कृषी आणि अन्न प्रक्रिया मशिनरीची एक विश्वासार्ह उत्पादक कंपनी आहे, जी कार्यक्षमता, अचूकता आणि दीर्घकाळ टिकणाऱ्या कामगिरीसाठी उत्पादने पुरवते.",
      introDesc: "बेदाणा प्रक्रिया आणि डाळिंब मशिनरीपासून कन्व्हेयर सिस्टिम्स आणि सानुकूल उपकरणांपर्यंत, आम्ही शेतकऱ्यांना आणि अन्न प्रक्रिया उद्योगांना मदत करतो.",
      feature1: "अचूक इंजिनिअर केलेली मशीन्स",
      feature2: "उत्कृष्ट दर्जाचे उत्पादन",
      feature3: "विश्वासार्ह सेवा आणि मदत",
      feature4: "सानुकूल औद्योगिक उपाय",
      btnExploreStory: "आमची गोष्ट जाणून घ्या",
      videoCaption: "आमचे हाय-परफॉर्मन्स बेदाणा प्रक्रिया मशीन कार्य करताना पहा",
      introBadgeSince: "१९८९ पासून कार्यरत",
      introBadgeLegacy: "३५+ वर्षांचा वारसा",

      // ─── COMMITMENT / PROMISES ───
      commitTitle: "गुणवत्तेची आमची",
      commitTitleHighlight: "वचनबद्धता",
      why1Title: "उत्कृष्ट गुणवत्ता",
      why1Desc: "प्रत्येक मशीन काळजीपूर्वक निवडलेल्या साहित्याने बनवले जाते आणि कृषी आणि अन्न प्रक्रिया उद्योगांसाठी चाचणी केले जाते.",
      why2Title: "उच्च कार्यक्षमता",
      why2Desc: "आमचे नाविन्यपूर्ण मशिनरी उत्पादकता वाढवण्यासाठी आणि दैनंदिन कामकाज सोपे करण्यासाठी डिझाइन केलेले आहे.",
      why3Title: "सपोर्ट सेवा",
      why3Desc: "तुमचा व्यवसाय आत्मविश्वासाने चालवण्यासाठी आम्ही विश्वासार्ह तांत्रिक मदत आणि ग्राहक सपोर्ट देतो.",

      // ─── PROCESS / HOW IT WORKS ───
      processTitle: "डिझाइनपासून",
      processTitleHighlight: "डिलिव्हरीपर्यंत",
      step1Title: "गरज विश्लेषण",
      step1Desc: "योग्य मशिनरी सुचवण्यापूर्वी आम्ही तुमच्या प्रक्रियेच्या गरजा समजून घेतो.",
      step2Title: "सानुकूल इंजिनिअरिंग",
      step2Desc: "आमची इंजिनिअरिंग टीम तुमच्या गरजेनुसार व्यावहारिक आणि कार्यक्षम मशीन्स डिझाइन करते.",
      step3Title: "अचूक उत्पादन",
      step3Desc: "टिकाऊपणा आणि सातत्यपूर्ण कामगिरी सुनिश्चित करण्यासाठी प्रत्येक मशीन कुशलतेने बनवले जाते.",
      step4Title: "इन्स्टॉलेशन आणि सपोर्ट",
      step4Desc: "आम्ही इन्स्टॉलेशन, मशीन मार्गदर्शन आणि सुरळीत कामकाजासाठी सतत मदत करतो.",

      // ─── HOME SERVICES HIGHLIGHT ───
      servicesTitle: "सर्वसमावेशक",
      servicesTitleHighlight: "अभियांत्रिकी सेवा",
      btnAllServices: "सर्व सेवा",

      // ─── HOME TESTIMONIALS ───
      testiTitle: "आमचे ग्राहक",
      testiTitleHighlight: "काय म्हणतात",

      // ─── WHY CHOOSE US ───
      whyChooseTitle: "दिग्विजय इंडस्ट्रीज",
      whyChooseTitleHighlight: "का निवडावी?",
      wc1Title: "विश्वासार्ह अनुभव",
      wc1Desc: "भक्कम इंजिनिअरिंग ज्ञान आणि उद्योग अनुभवासह विश्वासार्ह मशिनरी उपाय देणे.",
      wc2Title: "उत्कृष्ट कामगिरी",
      wc2Desc: "सुरळीत कामकाज, सातत्यपूर्ण उत्पादन आणि दीर्घकालीन उत्पादकतेसाठी बनवलेली मशीन्स.",
      wc3Title: "जागतिक दर्जा",
      wc3Desc: "देशांतर्गत आणि आंतरराष्ट्रीय उद्योगांसाठी योग्य गुणवत्ता मानकांचा वापर करून उत्पादित.",
      wc4Title: "ग्राहक सपोर्ट",
      wc4Desc: "मशीनचे कार्यक्षम कामकाज आणि ग्राहकांचे समाधान सुनिश्चित करण्यासाठी समर्पित मदत.",
      wc5Title: "स्वतःचे उत्पादन",
      wc5Desc: "गुणवत्ता, अचूकता आणि सातत्य राखण्यासाठी एकाच छताखाली डिझाइन आणि उत्पादित.",
      wc6Title: "उत्कृष्ट उत्पादकता",
      wc6Desc: "कामकाजाचे कष्ट कमी करून व्यवसायांची कार्यक्षमता सुधारण्यास मदत करण्यासाठी इंजिनिअर केलेले.",

      // ─── HOME CTA ───
      ctaTitle: "योग्य कृषी प्रक्रिया मशीन शोधत आहात?",
      ctaDesc: "तुमच्या उत्पादन गरजांनुसार सानुकूल कृषी आणि अन्न प्रक्रिया मशिनरीसाठी आमच्या तज्ञांशी बोला.",
      btnCallExperts: "तज्ञांशी बोला",

      // ─── ABOUT PAGE ───
      aboutHeroBadge: "१९८९ पासून कार्यरत",
      aboutHeroTitle1: "आमच्या",
      aboutHeroTitle2: "बद्दल",
      aboutHeroDesc: "१९८९ पासून, दिग्विजय इंडस्ट्रीज शेतकरी, व्यापारी, कोल्ड स्टोरेज आणि अन्न प्रक्रिया उद्योगांसाठी अचूक इंजिनिअर केलेली कृषी व अन्न प्रक्रिया मशिनरी तयार करत आहे.",
      aboutStoryTag: "आमची गोष्ट",
      aboutStoryTitle1: "आधुनिक शेतीसाठी",
      aboutStoryTitle2: "उत्कृष्ट अभियांत्रिकी",
      aboutStoryLead: "दिग्विजय इंडस्ट्रीज प्रगत कृषी आणि अन्न प्रक्रिया मशिनरीची रचना आणि निर्मिती करते, ज्यामुळे कार्यक्षमता, उत्पादकता आणि उत्पादनाचा दर्जा वाढतो.",
      aboutStoryP2: "बेदाणा प्रक्रिया आणि डाळिंब मशिनरीपासून ते कन्व्हेयर सिस्टिम्स आणि ऑटोमेशन सोल्यूशन्सपर्यंत, प्रत्येक मशीन टिकाऊपणा आणि अचूक कामगिरीसाठी ओळखले जाते.",
      aboutStoryP3: "बेदाणा (मनुका) प्रक्रिया मशिनरी क्षेत्रातील अग्रणी म्हणून, आम्ही भारत आणि जगभरातील १२+ देशांमध्ये गुणवत्तेचे मानक स्थापित केले आहे.",
      aboutCheck1: "कृषी मशिनरी तज्ञ",
      aboutCheck2: "अन्न प्रक्रिया उपाय",
      aboutCheck3: "ग्राहक-केंद्रित इंजिनिअरिंग",
      aboutCheck4: "विश्वासार्ह उत्पादन",
      aboutEst: "स्थापना १९८९",
      aboutLegacy: "३५+ वर्षांचा वारसा",
      aboutFounderTag: "संस्थापकांविषयी",
      aboutFounderTitle: "दिग्विजय इंडस्ट्रीजचे नेतृत्व",
      aboutFounderQuote: "\"दिग्विजय इंडस्ट्रीजमध्ये, आमचा दृष्टिकोन नेहमीच अशी नाविन्यपूर्ण मशिनरी बनवण्याचा राहिला आहे, ज्यामुळे शेतकरी आणि प्रक्रिया उद्योगांना शाश्वत प्रगती आणि अधिक उत्पादकता मिळेल.\"",
      aboutFounderBio: "१९८९ पासून दिग्विजय इंडस्ट्रीज अचूक अभियांत्रिकी, उत्कृष्ट कारागिरी आणि ग्राहकाभिमुख नाविन्यतेसह कृषी व अन्न प्रक्रिया उपकरणे तयार करत आहे. प्रत्येक मशीन आमच्या गुणवत्तेची साक्ष देते.",
      aboutFounderBadge: "१९८९ पासून उत्पादन क्षेत्रात अग्रगण्य",
      aboutAchieve1: "कृषी मशिनरी विशेषज्ञ",
      aboutAchieve2: "अन्न प्रक्रिया तंत्रज्ञान",
      aboutAchieve3: "अचूक अभियांत्रिकी उत्कृष्टता",
      aboutAchieve4: "ग्राहकाभिमुख नवकल्पना",
      aboutVmTag: "आमची मूल्ये व ध्येय",
      aboutVmTitle: "दृष्टी आणि ध्येय",
      aboutVisionTitle: "आमची दृष्टी (Vision)",
      aboutVisionDesc: "नवकल्पना, गुणवत्ता अभियांत्रिकी आणि शाश्वत उत्पादनाद्वारे कृषी व अन्न प्रक्रिया मशिनरीचे जागतिक स्तरावर विश्वासार्ह उत्पादक बनणे.",
      aboutVision1: "नाविन्यपूर्ण कृषी मशिनरी उपाय देणे",
      aboutVision2: "शेतकरी आणि प्रक्रिया उद्योगांना सक्षम करणे",
      aboutVision3: "विश्वासार्ह आणि उच्च क्षमतेची मशीन्स बनवणे",
      aboutVision4: "गुणवत्ता आणि ग्राहकांच्या विश्वासाने विस्तार करणे",
      aboutMissionTitle: "आमचे ध्येय (Mission)",
      aboutMissionDesc: "उत्पादकता वाढवणारी, शारीरिक श्रम कमी करणारी आणि अखंड ग्राहक सेवेसह दीर्घकालीन मूल्य देणारी टिकाऊ मशीन्स तयार करणे.",
      aboutMission1: "अचूक प्रक्रिया करणारी मशिनरी तयार करणे",
      aboutMission2: "उत्कृष्ट गुणवत्ता आणि तांत्रिक सपोर्ट पुरवणे",
      aboutMission3: "कार्यक्षम आणि सानुकूल मशीन उपाय विकसित करणे",
      aboutMission4: "ग्राहकांचे दीर्घकालीन समाधान सुनिश्चित करणे",
      aboutValuesTag: "मार्गदर्शक तत्त्वे",
      aboutValuesTitle: "आमची मूळ मूल्ये",
      valIntegrity: "प्रामाणिकपणा व सचोटी",
      valIntegrityDesc: "आम्ही प्रामाणिक व्यवहार, उत्तम कारागिरी आणि जबाबदार व्यवसाय पद्धतींद्वारे विश्वास निर्माण करतो.",
      valInnovation: "नवकल्पना व नाविन्यता",
      valInnovationDesc: "व्यावहारिक अभियांत्रिकी आणि प्रगत उत्पादन पद्धतींसह आम्ही आमची मशिनरी सतत सुधारतो.",
      valCustomerFirst: "ग्राहक प्रथम",
      valCustomerFirstDesc: "प्रत्येक मशीन ग्राहकांच्या गरजा आणि त्यांच्या दीर्घकालीन समाधानासाठी डिझाइन केले जाते.",
      valQuality: "गुणवत्ता उत्कृष्टता",
      valQualityDesc: "ग्राहकांपर्यंत पोहोचण्यापूर्वी प्रत्येक मशीनची अत्यंत कडक गुणवत्ता चाचणी घेतली जाते.",
      valExpertise: "अभियांत्रिकी कौशल्य",
      valExpertiseDesc: "आमची अनुभवी टीम आधुनिक शेती आणि अन्न प्रक्रियेसाठी विश्वासार्ह मशीन्स विकसित करते.",
      valGrowth: "शाश्वत विकास",
      valGrowthDesc: "आम्ही उत्पादकता वाढवणारी आणि पर्यावरणपूरक उत्पादनाला प्रोत्साहन देणारी कार्यक्षम मशीन्स बनवतो.",
      aboutInfraTag: "आमची फॅक्टरी",
      aboutInfraTitle1: "अत्याधुनिक उत्पादन",
      aboutInfraTitle2: "पायाभूत सुविधा",
      aboutInfraP1: "आमच्या आधुनिक उत्पादन कारखान्यात उच्च दर्जाची फॅब्रिकेशन, मशिनिंग, असेंब्ली आणि गुणवत्ता तपासणी यंत्रणा उपलब्ध आहे.",
      aboutInfraP2: "उत्पादनाचा प्रत्येक टप्पा कुशल तंत्रज्ञांद्वारे अचूकता आणि दर्जेदार कामगिरीसाठी काळजीपूर्वक तपासला जातो.",
      aboutInfraStat1Title: "अत्याधुनिक उत्पादन",
      aboutInfraStat1Sub: "अचूक अभियांत्रिकी",
      aboutInfraStat2Title: "गुणवत्ता तपासणी",
      aboutInfraStat2Sub: "विश्वासार्ह कामगिरी",
      aboutInfraStat3Title: "ग्राहक सपोर्ट",
      aboutInfraStat3Sub: "संपूर्ण सहकार्य",

      // ─── PRODUCTS PAGE ───
      productsBadge: "उत्पादन श्रेणी",
      productsTitle1: "आमची",
      productsTitle2: "उत्पादने",
      productsSubtitle: "कार्यक्षम कामकाजासाठी अचूकतेने तयार केलेली कृषी आणि अन्न प्रक्रिया मशिनरी.",
      catAll: "सर्व",
      catBedana: "बेदाणा प्रक्रिया",
      catWashing: "धुलाई व स्वच्छता",
      catGrading: "ग्रेडिंग व सॉर्टिंग",
      catConveyor: "कन्व्हेयर व हँडलिंग",
      catCustom: "सानुकूल उपकरणे",
      catFoodProcessing: "अन्न प्रक्रिया",
      catIndustrial: "औद्योगिक उपकरणे",
      catAgri: "कृषी यंत्रसामग्री",
      prodCapacity: "क्षमता:",
      btnViewDetail: "तपशील पहा",
      noProductsFound: "या श्रेणीमध्ये उत्पादने आढळली नाहीत.",
      loadingText: "लोड होत आहे...",

      // ─── PRODUCT DETAIL PAGE ───
      bcHome: "होम",
      bcProducts: "उत्पादने",
      bcAllProducts: "सर्व उत्पादने",
      zoomHint: "पूर्ण दृश्य आणि झूमसाठी क्लिक करा",
      pdKeyFeatures: "प्रमुख वैशिष्ट्ये",
      pdProductOverview: "उत्पादनाचे विहंगावलोकन",
      pdDetailedSpecs: "तपशीलवार माहिती",
      pdBtnEnquire: "चौकशी करा",
      pdBtnWhatsApp: "व्हॉट्सॲपवर त्वरित चॅट करा",
      pdQuoteBadge: "थेट फॅक्टरी सल्लामसलत",
      pdQuoteTitle: "सल्ला व कोटेशनसाठी विनंती करा",
      pdQuoteDesc: "तांत्रिक सल्ला, सानुकूल मशिनरी आणि फॅक्टरी किमतीच्या माहितीसाठी खालील फॉर्म भरा.",
      pdQuoteSpecificDesc: "{{name}} मध्ये स्वारस्य आहे? तांत्रिक सल्ला, सानुकूल मशिनरी आणि फॅक्टरी किमतीच्या माहितीसाठी खालील फॉर्म भरा.",
      pdBedanaOverview: "{{name}} हे उच्च उत्पादकता आणि विश्वासार्ह औद्योगिक कामगिरीसह मोठ्या प्रमाणावर बेदाणा (मनुका) प्रक्रियेसाठी विशेषतः डिझाइन केलेले आहे. हे उत्पादनाचा दर्जा सातत्यपूर्ण ठेवून अखंड उत्पादन देते. हेवी-ड्युटी वापरासाठी तयार केलेले हे मशीन व्यावसायिक अन्न प्रक्रिया उद्योगांसाठी अत्यंत फायदेशीर आहे.",
      pdBedanaShortDesc: "अखंड गुणवत्ता आणि उच्च क्षमतेसह बेदाणा (मनुका) स्वच्छता, धुलाई आणि प्रक्रियेसाठी अत्याधुनिक मशिनरी.",
      pdBedanaSpec1: "दिग्विजय इंडस्ट्रीजचे {{name}} व्यावसायिक बेदाणा उत्पादन आणि ड्रायफ्रूट प्रक्रिया उद्योगांची वाढती मागणी पूर्ण करण्यासाठी अचूकतेने तयार केले आहे. हेवी-ड्युटी औद्योगिक फॅब्रिकेशनसह बनवलेले हे मशीन उच्च प्रक्रिया कार्यक्षमता, सातत्यपूर्ण गुणवत्ता आणि विश्वासार्ह दीर्घकालीन कामगिरी देते. याचे मजबूत डिझाइन मानवी श्रम कमी करून एकूण उत्पादन क्षमता मोठ्या प्रमाणावर वाढवते.",
      pdBedanaSpec2: "उत्कृष्ट अभियांत्रिकी मानकांचा वापर करून तयार केलेले हे मशीन सुरळीत प्रक्रिया, कमी देखभाल खर्च आणि ऊर्जा-कार्यक्षम कामगिरी सुनिश्चित करते, ज्यामुळे हे आधुनिक अन्न प्रक्रिया केंद्रांसाठी एक सर्वोत्तम गुंतवणूक ठरते.",
      pdBedanaSpec3: "या मशिनरीची मुख्य वैशिष्ट्ये म्हणजे मजबूत हेवी-ड्युटी बांधकाम, उच्च प्रक्रिया क्षमता, सतत चालणारी उत्पादन प्रणाली, विश्वासार्ह औद्योगिक कामगिरी, सुलभ देखभाल, वीज बचत आणि वापरण्यास अत्यंत सोपी नियंत्रण प्रणाली.",
      pdBedanaSpec4: "हे मशीन बेदाणा उत्पादक, ड्रायफ्रूट प्रक्रिया युनिट्स, अन्न प्रक्रिया कंपन्या, कृषी प्रक्रिया उद्योग, पॅकेजिंग प्लांट्स आणि मोठ्या प्रमाणावर उत्पादन करणाऱ्या निर्यातदारांसाठी अत्यंत योग्य आहे.",
      pdGeneralOverview: "{{name}} हे कृषी आणि अन्न प्रक्रिया उद्योगांसाठी उच्च उत्पादकता, अचूक कामगिरी आणि दीर्घायुष्यासह विशेषतः इंजिनिअर केलेले आहे.",
      pdGeneralSpec1: "दिग्विजय इंडस्ट्रीजचे {{name}} औद्योगिक मानकांनुसार डिझाइन केलेले असून, उच्च प्रक्रिया कार्यक्षमता आणि टिकाऊ बांधकाम प्रदान करते.",
      pdGeneralSpec2: "उत्कृष्ट अभियांत्रिकी मानकांचा वापर करून तयार केलेले हे मशीन आधुनिक औद्योगिक सुविधांसाठी सुरळीत प्रक्रिया, कमी देखभाल आणि ऊर्जा-कार्यक्षम कामगिरी सुनिश्चित करते.",
      pdGeneralSpec3: "दैनंदिन कारखान्यातील कामाचा ताण सहज हाताळण्यासाठी हे मशीन मजबूत साहित्य, वापरण्यास सोपी नियंत्रणे आणि विश्वासार्ह सुरक्षा यंत्रणेसह तयार केले गेले आहे.",
      pdNotFoundTitle: "उत्पादन आढळले नाही",
      pdNotFoundDesc: "तुम्ही शोधत असलेले मशीन अद्यतनित केले गेले आहे किंवा अनुपलब्ध आहे.",
      pdBackToCatalog: "उत्पादन कॅटलॉगवर परत जा",
      featCustomSolutions: "सानुकूल औद्योगिक उपाय",
      featStainlessSteel: "SS304 स्टेनलेस स्टील व M.S. मध्ये निर्मित",
      featHeavyDuty: "मजबूत हेवी-ड्युटी औद्योगिक बांधकाम",
      featHighPerf: "उच्च कार्यक्षमता आणि अविरत उत्पादन",
      featEnergySaving: "ऊर्जा बचत आणि किफायतशीर कामकाज",
      featLowMaint: "कमी देखभाल व दीर्घायुष्य",
      formPhonePlaceholder: "उदा. ९८७६५४३२१०",
      formEmailPlaceholder: "तुमचा ईमेल पत्ता टाका",

      // ─── SERVICES PAGE ───
      servicesBadge: "आम्ही काय देतो",
      servicesTitle1: "आमच्या",
      servicesTitle2: "सेवा",
      servicesSubtitle: "इन्स्टॉलेशन आणि कमिशनिंगपासून ते देखभाल, तांत्रिक मदत आणि सानुकूल इंजिनिअरिंगपर्यंत आम्ही विश्वासार्ह सेवा देतो.",
      svcInstallTitle: "इन्स्टॉलेशन आणि कमिशनिंग",
      svcInstallDesc: "मशीन सुरळीत सुरू होण्यासाठी तज्ञांकडून ऑन-साइट इन्स्टॉलेशन, ट्रायल रन आणि मशीन ट्यूनिंग.",
      svcMaintTitle: "नियमित देखभाल सेवा",
      svcMaintDesc: "मशीनचे कामकाज बंद न पडता दीर्घकाळ टिकण्यासाठी नियमित तपासणी आणि वेळेवर सर्व्हिसिंग.",
      svcPartsTitle: "ओरिजिनल सुटे भाग (Spare Parts)",
      svcPartsDesc: "उत्पादन अखंड चालू राहण्यासाठी अचूक आणि ओरिजिनल सुट्या भागांचा जलद पुरवठा.",
      svcTrainingTitle: "ऑपरेटर प्रशिक्षण",
      svcTrainingDesc: "जास्तीत जास्त उत्पादन आणि सुरक्षिततेसाठी तुमच्या कर्मचाऱ्यांना सविस्तर मशीन प्रशिक्षण.",
      svcCustomTitle: "सानुकूल इंजिनिअरिंग",
      svcCustomDesc: "तुमच्या कारखान्याची जागा आणि गरजेनुसार सानुकूल मशिन्स व कन्व्हेयर डिझाइन.",
      svcSupportTitle: "२४/७ तांत्रिक मदत",
      svcSupportDesc: "कोणत्याही तांत्रिक अडचणी त्वरित सोडवण्यासाठी फोन, व्हिडिओ आणि ऑन-साइट इंजिनिअरिंग सपोर्ट.",
      svcConveyorTitle: "कन्व्हेयर व मटेरिअल हँडलिंग सोल्यूशन्स",
      svcConveyorDesc: "कच्चा माल आणि तयार उत्पादनांच्या अखंड व सुरक्षित वाहतुकीसाठी सानुकूल कन्व्हेयर आणि मटेरिअल हँडलिंग सोल्यूशन्स.",
      svcExportTitle: "निर्यात आणि लॉजिस्टिक्स सोल्यूशन्स",
      svcExportDesc: "कृषी व अन्न प्रक्रिया मशिनरीसाठी सुरक्षित पॅकेजिंग, शिपमेंट समन्वय, कस्टम कागदपत्रे आणि वेळेवर आंतरराष्ट्रीय डिलिव्हरीसह विश्वासार्ह निर्यात सहाय्य.",
      svcConsultTitle: "तांत्रिक सल्ला आणि प्रकल्प सहाय्य",
      svcConsultDesc: "उत्पादकता वाढवण्यासाठी योग्य मशिनरी निवड, प्रक्रिया युनिट लेआउट आणि ऑटोमेशन नियोजनासाठी तज्ञांचे व्यावसायिक मार्गदर्शन.",
      catMaterialHandling: "मटेरिअल हँडलिंग",
      catAirHandling: "एअर हँडलिंग",
      catHeatingSystems: "हीटिंग सिस्टीम्स",

      // ─── CONTACT PAGE ───
      contactBadge: "संपर्क साधा",
      contactTitle1: "दिग्विजय इंडस्ट्रीजशी",
      contactTitle2: "संपर्क साधा",
      contactSubtitle: "कृषी व अन्न प्रक्रिया मशिनरी, उत्पादन चौकशी, सानुकूल मशीन किंवा तांत्रिक मदतीसाठी आमच्या तज्ञांशी संपर्क साधा.",
      contactDirectComm: "थेट संवाद",
      contactInfoTitle: "संपर्क माहिती",
      contactInfoSubtitle: "मशिनरी चौकशी, सानुकूल प्रक्रिया उपाय किंवा तांत्रिक मदतीसाठी आमच्याशी संपर्क साधा.",
      contactAddressLabel: "कारखाना व कार्यालयाचा पत्ता",
      contactPhoneLabel: "फोन सपोर्ट",
      contactEmailLabel: "ईमेल पत्ता",
      tabGeneralInquiry: "सामान्य चौकशी",
      tabCareerApp: "नोकरीसाठी अर्ज",
      formFullName: "पूर्ण नाव",
      formEnterFullName: "तुमचे पूर्ण नाव टाका",
      formEmail: "ईमेल पत्ता",
      formPhone: "फोन नंबर",
      formEnterPhone: "तुमचा फोन नंबर टाका",
      formMessage: "संदेश",
      formMessagePlaceholder: "तुमची चौकशी किंवा मशिनरीची गरज येथे लिहा...",
      formSendMessage: "संदेश पाठवा",
      formSending: "पाठवत आहे...",
      formMsgSuccess: "संदेश यशस्वीरित्या पाठवला गेला!",
      formPosition: "पदासाठी अर्ज",
      formSelectPosition: "पद निवडा",
      posMechEng: "मेकॅनिकल इंजिनिअर",
      posTech: "तंत्रज्ञ (Technician)",
      posSales: "सेल्स एक्झिक्युटिव्ह",
      posOther: "इतर",
      formExperience: "कामाचा अनुभव (वर्षे)",
      formUploadResume: "बायोडाटा अपलोड करा (PDF/DOC, कमाल 700KB)",
      formSubmitApp: "अर्ज सादर करा",
      formSubmitting: "सादर होत आहे...",
      formAppSuccess: "अर्ज यशस्वीरित्या सादर झाला आहे!",
      contactMapTitle: "नकाशावर आमचे स्थान पहा",
      alertMissingTitle: "अपूर्ण माहिती",
      alertMissingText: "कृपया तुमचे नाव आणि फोन नंबर प्रविष्ट करा.",
      alertSuccessTitle: "विनंती यशस्वीरित्या पाठवली!",
      alertSuccessText: "आपल्या स्वारस्याबद्दल धन्यवाद. आमची तांत्रिक टीम लवकरच आपल्याशी संपर्क साधेल.",
      alertErrorTitle: "सबमिशन अयशस्वी",
      alertErrorText: "काहीतरी चूक झाली. कृपया फोन किंवा व्हॉट्सॲपद्वारे आमच्याशी संपर्क साधा.",

      // ─── FAQ PAGE ───
      faqBadge: "मदत केंद्र",
      faqTitle1: "नेहमी विचारले जाणारे",
      faqTitle2: "प्रश्न (FAQ)",
      faqSubtitle: "आमची उत्पादने, सेवा आणि कार्यपद्धतींबद्दल वारंवार विचारल्या जाणाऱ्या प्रश्नांची उत्तरे येथे मिळवा.",
      faqNoFaqs: "या श्रेणीमध्ये प्रश्न उपलब्ध नाहीत.",
      faqStillQuestions: "अजूनही प्रश्न आहेत का?",
      faqStillQuestionsDesc: "तुम्हाला आवश्यक असलेले उत्तर सापडले नाही? थेट आमच्या टीमशी संपर्क साधा.",
      faqContactBtn: "संपर्क साधा",
      faqQ1: "बेदाणा प्रक्रिया मशिनरीची प्रक्रिया क्षमता किती आहे?",
      faqA1: "आमचे बेदाणा प्रक्रिया मशीन ताशी १ टन ते ४ टन क्षमता देते, जे कमीत कमी मानवी श्रमात अखंड व्यावसायिक उत्पादनासाठी डिझाइन केलेले आहे.",
      faqQ2: "मशिनरी बनवण्यासाठी कोणते साहित्य वापरले जाते?",
      faqA2: "सर्व अन्न संपर्कात येणारे भाग फूड-ग्रेड SS304 स्टेनलेस स्टील आणि दीर्घकाळ टिकणाऱ्या उच्च दर्जाच्या माइल्ड स्टीलने बनवले जातात.",
      faqQ3: "तुम्ही ऑन-साइट इन्स्टॉलेशन आणि ऑपरेटर प्रशिक्षण देता का?",
      faqA3: "होय, आमची अनुभवी इंजिनिअरिंग टीम संपूर्ण ऑन-साइट इन्स्टॉलेशन, ट्रायल रन आणि ऑपरेटर प्रशिक्षण देते.",
      faqQ4: "तुम्ही भारताबाहेर मशिनरी निर्यात करता का?",
      faqA4: "होय, दिग्विजय इंडस्ट्रीजने जगभरातील १२ पेक्षा जास्त देशांमध्ये कृषी आणि अन्न प्रक्रिया मशिनरी यशस्वीरित्या निर्यात केली आहे.",

      // ─── BLOGS & BLOG POST PAGE ───
      blogsBadge: "माहिती व लेख",
      blogsTitle1: "आमचे",
      blogsTitle2: "ब्लॉग्स",
      blogsSubtitle: "कृषी मशिनरी, अन्न प्रक्रिया तंत्रज्ञान, मशीन देखभाल आणि दिग्विजय इंडस्ट्रीजच्या नवनवीन तंत्रज्ञानाविषयी सविस्तर लेख वाचा.",
      searchArticles: "लेख शोधा...",
      noArticlesFound: "कोणताही लेख आढळला नाही.",
      tryDifferentSearch: "दुसरा शब्द किंवा श्रेणी शोधून पहा.",
      readArticle: "संपूर्ण लेख वाचा",
      backToAllArticles: "सर्व लेखांवर परत जा",
      backToBlogs: "ब्लॉग्सवर परत जा",
      blogNotFound: "ब्लॉग पोस्ट आढळली नाही.",

      // ─── FOOTER ───
      footerAboutDesc: "गेल्या तीन दशकांपासून दिग्विजय इंडस्ट्रीज टिकाऊपणा, कार्यक्षमता आणि विश्वासार्ह गुणवत्तेसह उच्च क्षमतेच्या कृषी व अन्न प्रक्रिया मशिनरीची निर्मिती करत आहे.",
      footerQuickLinks: "महत्त्वाच्या लिंक्स",
      footerContactInfo: "संपर्क माहिती",
      footerOpeningHours: "कामाची वेळ",
      footerMonSat: "सोमवार - शनिवार:",
      footerTime: "सकाळी ०९.०० ते संध्याकाळी ०६.००",
      footerWeeklyOff: "साप्ताहिक सुट्टी: मंगळवार",
      footerRights: "सर्व हक्क राखीव.",
      footerDesignedBy: "डिझाइन आणि विकसित केले"
    }
  },
  kn: {
    translation: {
      // ─── NAVBAR & COMMON ───
      navHome: "Home",
      navAbout: "ನಮ್ಮ ಬಗ್ಗೆ",
      navProducts: "ಉತ್ಪನ್ನಗಳು",
      navServices: "ಸೇವೆಗಳು",
      navBlog: "ಬ್ಲಾಗ್",
      navFAQ: "ಪ್ರಶ್ನೋತ್ತರಗಳು (FAQ)",
      navContact: "ಸಂಪರ್ಕಿಸಿ",
      navCallNow: "ಈಗಲೇ ಕರೆ ಮಾಡಿ",
      navLanguage: "ಭಾಷೆ",
      navContactLabel: "ಸಂಪರ್ಕ",

      // ─── HERO SLIDES & CONTROLS ───
      heroBadge1: "ಎಂಜಿನಿಯರ್ ಮಾಡಿದ. ವಿಶ್ವಾಸಾರ್ಹ. ಸಾಬೀತಾದ.",
      heroBadge2: "ಗುಣಮಟ್ಟ. ಕಾರ್ಯಾಚರಣೆ. ನಾವೀನ್ಯತೆ.",
      heroBadge3: "ವಿಶ್ವಾಸಾರ್ಹ. ಬಾಳಿಕೆ ಬರುವ. ಸಮರ್ಥ.",
      heroTitle1_1: "ಖಚಿತ ಕೃಷಿ",
      heroTitle1_2: "ಸಂಸ್ಕರಣಾ ಪರಿಹಾರಗಳು",
      heroDesc1: "ಒಣದ್ರಾಕ್ಷಿ, ಒಣ ಹಣ್ಣುಗಳು ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣೆಗಾಗಿ ಸುಧಾರಿತ ಯಂತ್ರೋಪಕರಣಗಳು—ಉತ್ಪಾದಕತೆ ಮತ್ತು ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಹೆಚ್ಚಿಸಲು ನಿರ್ಮಿಸಲಾಗಿದೆ.",
      heroTitle2_1: "ಕೃಷಿ ಯಂತ್ರೋಪಕರಣಗಳಲ್ಲಿ",
      heroTitle2_2: "ಕ್ರಾಂತಿಕಾರಿ ಬದಲಾವಣೆ",
      heroDesc2: "ಬೆಡಾನಾ ಸಂಸ್ಕರಣಾ ಯಂತ್ರಗಳಿಂದ ಹಿಡಿದು ಏರ್ ಕ್ಲಾಸಿಫೈಯರ್‌ಗಳು ಮತ್ತು ರವಾನೆ ಯಂತ್ರಗಳವರೆಗೆ, ಆಧುನಿಕ ಕೈಗಾರಿಕೆಗಳಿಗೆ ನಾವು ನಂಬಿಕಾರ್ಹ ಉಪಕರಣ ನೀಡುತ್ತೇವೆ.",
      heroTitle3_1: "ಕೈಗಾರಿಕಾ",
      heroTitle3_2: "ಶ್ರೇಷ್ಠತೆಯ ನಿರ್ಮಾಣ",
      heroDesc3: "ಭಾರತ ಮತ್ತು ಅಂತಾರಾಷ್ಟ್ರೀಯ ಮಾರುಕಟ್ಟೆಗಳಲ್ಲಿ ವ್ಯವಹಾರಗಳಿಗಾಗಿ ಉತ್ತಮ ಬೆಂಬಲದೊಂದಿಗೆ ವಿಶ್ವಾಸಾರ್ಹ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳು.",
      btnExploreProducts: "ಉತ್ಪನ್ನಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
      btnContactSales: "ಸಂಪರ್ಕಿಸಿ",
      heroBadgeIsoTitle: "ISO ಪ್ರಮಾಣೀಕೃತ",
      heroBadgeIsoDesc: "ಗುಣಮಟ್ಟದ ಖಾತ್ರಿ",
      heroBadgeNationsTitle: "3ಕ್ಕೂ ಹೆಚ್ಚು ದೇಶಗಳು",
      heroBadgeNationsDesc: "ಜಾಗತಿಕ ರಫ್ತುಗಳು",
      heroBadgeYieldTitle: "ಹೆಚ್ಚಿನ ಇಳುವರಿ",
      heroBadgeYieldDesc: "ಕೃಷಿ ಸಂಸ್ಕರಣೆ",
      heroBadgeZeroMaintTitle: "ಝೀರೋ ನಿರ್ವಹಣೆ",
      heroBadgeZeroMaintDesc: "ಬಾಳಿಕೆ ಬರುವ ವಿನ್ಯಾಸ",
      heroBadgeFastDeliveryTitle: "ತ್ವರಿತ ವಿತರಣೆ",
      heroBadgeFastDeliveryDesc: "ಜಾಗತಿಕ ಲಾಜಿಸ್ಟಿಕ್ಸ್",
      heroBadgeSupportTitle: "೨೪/೭ ಬೆಂಬಲ",
      heroBadgeSupportDesc: "ಗ್ರಾಹಕರ ಯಶಸ್ಸು",

      // ─── MARQUEE ───
      mq1: "೫೦೦೦+ ರೈತರ ನಂಬಿಕೆ",
      mq2: "ಝೀರೋ ಮೇಂಟೆನೆನ್ಸ್ ತಂತ್ರಜ್ಞಾನ",

      mq4: "3ಕ್ಕೂ ಹೆಚ್ಚು ದೇಶಗಳಿಗೆ ರಫ್ತುಗಳು",
      mq5: "೩೫+ ವರ್ಷಗಳ ಅನುಭವ",
      mq6: "ಭಾರತದ ಪ್ರಮುಖ ಅಗ್ರೋ ಮೆಷಿನರಿ",

      // ─── STATS ───
      stat1Label: "ಎಂಜಿನಿಯರಿಂಗ್ ಶ್ರೇಷ್ಠತೆಯ ವರ್ಷಗಳು",
      stat2Label: "ಅಳವಡಿಸಲಾದ ಯಂತ್ರಗಳು",
      stat3Label: "ರಫ್ತು ಮಾಡಿದ ದೇಶಗಳು",
      stat4Label: "ನಿರಂತರ ಬೆಂಬಲ",

      // ─── HOME INTRO ───
      introTitle: "ಗೆ ಸುಸ್ವಾಗತ",
      introLead: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳ ವಿಶ್ವಾಸಾರ್ಹ ತಯಾರಕರಾಗಿದ್ದು, ದೀರ್ಘಕಾಲಿಕ ಕಾರ್ಯಕ್ಷಮತೆಯ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುತ್ತದೆ.",
      introDesc: "ಒಣದ್ರಾಕ್ಷಿ ಸಂಸ್ಕರಣೆ ಮತ್ತು ದಾಳಿಂಬೆ ಯಂತ್ರೋಪಕರಣಗಳಿಂದ ಕನ್ವೇಯರ್ ವ್ಯವಸ್ಥೆಗಳು ಮತ್ತು ಕಸ್ಟಮ್ ಉಪಕರಣಗಳವರೆಗೆ, ನಾವು ರೈತರಿಗೆ ಮತ್ತು ಸಂಸ್ಕರಣಾ ಉದ್ಯಮಗಳಿಗೆ ನೆರವಾಗುತ್ತೇವೆ.",
      feature1: "ಖಚಿತ ಎಂಜಿನಿಯರ್ ಮಾಡಿದ ಯಂತ್ರಗಳು",
      feature2: "ಉತ್ತಮ ಗುಣಮಟ್ಟದ ಉತ್ಪಾದನೆ",
      feature3: "ವಿಶ್ವಾಸಾರ್ಹ ಸೇವೆ ಮತ್ತು ಬೆಂಬಲ",
      feature4: "ಅಗತ್ಯಕ್ಕೆ ತಕ್ಕ ಕೈಗಾರಿಕಾ ಪರಿಹಾರಗಳು",
      btnExploreStory: "ನಮ್ಮ ಕಥೆಯನ್ನು ಅನ್ವೇಷಿಸಿ",
      videoCaption: "ನಮ್ಮ ಹೈ-ಪರ್ಫಾರ್ಮೆನ್ಸ್ ಒಣದ್ರಾಕ್ಷಿ ಸಂಸ್ಕರಣಾ ಯಂತ್ರದ ಕಾರ್ಯಾಚರಣೆಯನ್ನು ವೀಕ್ಷಿಸಿ",
      introBadgeSince: "೧೯೮೯ ರಿಂದ ಕಾರ್ಯನಿರತ",
      introBadgeLegacy: "೩೫+ ವರ್ಷಗಳ ಪರಂಪರೆ",

      // ─── COMMITMENT / PROMISES ───
      commitTitle: "ಗುಣಮಟ್ಟಕ್ಕೆ ನಮ್ಮ",
      commitTitleHighlight: "ಬದ್ಧತೆ",
      why1Title: "ಉತ್ತಮ ಗುಣಮಟ್ಟ",
      why1Desc: "ಪ್ರತಿಯೊಂದು ಯಂತ್ರವನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ಆಯ್ಕೆ ಮಾಡಿದ ವಸ್ತುಗಳಿಂದ ನಿರ್ಮಿಸಲಾಗಿದೆ ಮತ್ತು ಪರೀಕ್ಷಿಸಲಾಗಿದೆ.",
      why2Title: "ಹೆಚ್ಚಿನ ಕಾರ್ಯಕ್ಷಮತೆ",
      why2Desc: "ನಮ್ಮ ನವೀನ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ಉತ್ಪಾದಕತೆಯನ್ನು ಹೆಚ್ಚಿಸಲು ಮತ್ತು ದೈನಂದಿನ ಕಾರ್ಯಾಚರಣೆಯನ್ನು ಸುಲಭಗೊಳಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.",
      why3Title: "ಸಮರ್ಪಿತ ಬೆಂಬಲ",
      why3Desc: "ನಿಮ್ಮ ವ್ಯವಹಾರವನ್ನು ಆತ್ಮವಿಶ್ವಾಸದಿಂದ ನಡೆಸಲು ನಾವು ತಾಂತ್ರಿಕ ನೆರವು ಮತ್ತು ಗ್ರಾಹಕ ಬೆಂಬಲವನ್ನು ನೀಡುತ್ತೇವೆ.",

      // ─── PROCESS / HOW IT WORKS ───
      processTitle: "ವಿನ್ಯಾಸದಿಂದ",
      processTitleHighlight: "ವಿತರಣೆಯವರೆಗೆ",
      step1Title: "ಅಗತ್ಯತೆಗಳ ವಿಶ್ಲೇಷಣೆ",
      step1Desc: "ಸರಿಯಾದ ಯಂತ್ರೋಪಕರಣ ಪರಿಹಾರವನ್ನು ಶಿಫಾರಸು ಮಾಡುವ ಮೊದಲು ನಾವು ನಿಮ್ಮ ಸಂಸ್ಕರಣಾ ಅಗತ್ಯಗಳನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳುತ್ತೇವೆ.",
      step2Title: "ಕಸ್ಟಮ್ ಎಂಜಿನಿಯರಿಂಗ್",
      step2Desc: "ನಮ್ಮ ಎಂಜಿನಿಯರಿಂಗ್ ತಂಡವು ನಿಮ್ಮ ಉತ್ಪಾದನಾ ಅಗತ್ಯಗಳಿಗೆ ಅನುಗುಣವಾಗಿ ಸಮರ್ಥ ಯಂತ್ರಗಳನ್ನು ವಿನ್ಯಾಸಗೊಳಿಸುತ್ತದೆ.",
      step3Title: "ಖಚಿತ ಉತ್ಪಾದನೆ",
      step3Desc: "ಬಾಳಿಕೆ ಮತ್ತು ಸ್ಥಿರ ಕಾರ್ಯಾಚರಣೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಪ್ರತಿಯೊಂದು ಯಂತ್ರವನ್ನು ಕುಶಲತೆಯಿಂದ ತಯಾರಿಸಲಾಗುತ್ತದೆ.",
      step4Title: "ಅಳವಡಿಕೆ ಮತ್ತು ಬೆಂಬಲ",
      step4Desc: "ಸುಗಮ ಕಾರ್ಯಾಚರಣೆಗಾಗಿ ನಾವು ಅಳವಡಿಕೆ, ಯಂತ್ರದ ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ನಿರಂತರ ಬೆಂಬಲವನ್ನು ಒದಗಿಸುತ್ತೇವೆ.",

      // ─── HOME SERVICES HIGHLIGHT ───
      servicesTitle: "ಸಮಗ್ರ",
      servicesTitleHighlight: "ಎಂಜಿನಿಯರಿಂಗ್ ಸೇವೆಗಳು",
      btnAllServices: "ಎಲ್ಲಾ ಸೇವೆಗಳು",

      // ─── HOME TESTIMONIALS ───
      testiTitle: "ನಮ್ಮ ಗ್ರಾಹಕರು",
      testiTitleHighlight: "ಏನು ಹೇಳುತ್ತಾರೆ",

      // ─── WHY CHOOSE US ───
      whyChooseTitle: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಅನ್ನು",
      whyChooseTitleHighlight: "ಏಕೆ ಆಯ್ಕೆ ಮಾಡಬೇಕು?",
      wc1Title: "ವಿಶ್ವಾಸಾರ್ಹ ಅನುಭವ",
      wc1Desc: "ಉತ್ತಮ ಎಂಜಿನಿಯರಿಂಗ್ ಜ್ಞಾನ ಮತ್ತು ಉದ್ಯಮದ ಅನುಭವದೊಂದಿಗೆ ನಂಬಿಕಾರ್ಹ ಯಂತ್ರೋಪಕರಣ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುವುದು.",
      wc2Title: "ಉತ್ತಮ ಕಾರ್ಯಕ್ಷಮತೆ",
      wc2Desc: "ಸುಗಮ ಕಾರ್ಯಾಚರಣೆ, ಸ್ಥಿರ ಉತ್ಪಾದನೆ ಮತ್ತು ದೀರ್ಘಕಾಲೀನ ಉತ್ಪಾದಕತೆಗಾಗಿ ನಿರ್ಮಿಸಲಾದ ಯಂತ್ರಗಳು.",
      wc3Title: "ಜಾಗತಿಕ ಗುಣಮಟ್ಟ",
      wc3Desc: "ದೇಶೀಯ ಮತ್ತು ಅಂತಾರಾಷ್ಟ್ರೀಯ ಉದ್ಯಮಗಳಿಗೆ ಸೂಕ್ತವಾದ ಗುಣಮಟ್ಟದ ಮಾನದಂಡಗಳನ್ನು ಬಳಸಿ ತಯಾರಿಸಲಾಗಿದೆ.",
      wc4Title: "ಗ್ರಾಹಕ ಬೆಂಬಲ",
      wc4Desc: "ಪರಿಣಾಮಕಾರಿ ಕಾರ್ಯಾಚರಣೆ ಮತ್ತು ಗ್ರಾಹಕರ ತೃಪ್ತಿಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಸಮರ್ಪಿತ ನೆರವು.",
      wc5Title: "ಸ್ವಂತ ಉತ್ಪಾದನೆ",
      wc5Desc: "ಗುಣಮಟ್ಟ, ನಿಖರತೆ ಮತ್ತು ಸ್ಥಿರತೆಯನ್ನು ಕಾಯ್ದುಕೊಳ್ಳಲು ಒಂದೇ ಸೂರಿನಡಿಯಲ್ಲಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ ಮತ್ತು ತಯಾರಿಸಲಾಗಿದೆ.",
      wc6Title: "ಹೆಚ್ಚಿನ ಉತ್ಪಾದಕತೆ",
      wc6Desc: "ಕಾರ್ಯಾಚರಣೆಯ ಶ್ರಮವನ್ನು ಕಡಿಮೆ ಮಾಡುವ ಮೂಲಕ ಉದ್ಯಮಗಳು ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಸುಧಾರಿಸಲು ನೆರವಾಗುತ್ತದೆ.",

      // ─── HOME CTA ───
      ctaTitle: "ಸೂಕ್ತವಾದ ಕೃಷಿ ಸಂಸ್ಕರಣಾ ಯಂತ್ರವನ್ನು ಹುಡುಕುತ್ತಿದ್ದೀರಾ?",
      ctaDesc: "ನಿಮ್ಮ ಉತ್ಪಾದನಾ ಅಗತ್ಯಗಳಿಗೆ ತಕ್ಕಂತೆ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳಿಗಾಗಿ ನಮ್ಮ ತಜ್ಞರೊಂದಿಗೆ ಮಾತನಾಡಿ.",
      btnCallExperts: "ನಮ್ಮ ತಜ್ಞರೊಂದಿಗೆ ಮಾತನಾಡಿ",

      // ─── ABOUT PAGE ───
      aboutHeroBadge: "೧೯೮೯ ರಿಂದ ಕಾರ್ಯನಿರತ",
      aboutHeroTitle1: "ನಮ್ಮ",
      aboutHeroTitle2: "ಬಗ್ಗೆ",
      aboutHeroDesc: "೧೯೮೯ ರಿಂದ, ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಸುಧಾರಿತ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ತಯಾರಿಸುತ್ತಿದ್ದು, ರೈತರು ಮತ್ತು ಸಂಸ್ಕರಣಾ ಉದ್ಯಮಗಳಿಗೆ ವಿಶ್ವಾಸಾರ್ಹ ಪರಿಹಾರಗಳನ್ನು ನೀಡುತ್ತಿದೆ.",
      aboutStoryTag: "ನಮ್ಮ ಕಥೆ",
      aboutStoryTitle1: "ಆಧುನಿಕ ಕೃಷಿಗಾಗಿ",
      aboutStoryTitle2: "ಶ್ರೇಷ್ಠ ಎಂಜಿನಿಯರಿಂಗ್",
      aboutStoryLead: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಸುಧಾರಿತ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ವಿನ್ಯಾಸಗೊಳಿಸುತ್ತದೆ ಮತ್ತು ತಯಾರಿಸುತ್ತದೆ, ಇದು ದಕ್ಷತೆ ಮತ್ತು ಗುಣಮಟ್ಟವನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ.",
      aboutStoryP2: "ಒಣದ್ರಾಕ್ಷಿ ಸಂಸ್ಕರಣೆ ಮತ್ತು ದಾಳಿಂಬೆ ಯಂತ್ರಗಳಿಂದ ಕನ್ವೇಯರ್ ವ್ಯವಸ್ಥೆಗಳು ಮತ್ತು ಕಸ್ಟಮ್ ಆಟೊಮೇಷನ್ ಪರಿಹಾರಗಳವರೆಗೆ ಪ್ರತಿಯೊಂದು ಯಂತ್ರವನ್ನು ಬಾಳಿಕೆಗಾಗಿ ನಿರ್ಮಿಸಲಾಗಿದೆ.",
      aboutStoryP3: "ಒಣದ್ರಾಕ್ಷಿ (ಬೇಡಾನಾ) ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳ ಕ್ಷೇತ್ರದಲ್ಲಿ ಪ್ರವರ್ತಕರಾಗಿ, ನಾವು ಭಾರತ ಮತ್ತು ೧೨+ ದೇಶಗಳಲ್ಲಿ ಗುಣಮಟ್ಟದ ಮಾನದಂಡವನ್ನು ಸ್ಥಾಪಿಸಿದ್ದೇವೆ.",
      aboutCheck1: "ಕೃಷಿ ಯಂತ್ರೋಪಕರಣ ತಜ್ಞರು",
      aboutCheck2: "ಆಹಾರ ಸಂಸ್ಕರಣಾ ಪರಿಹಾರಗಳು",
      aboutCheck3: "ಗ್ರಾಹಕ-ಕೇಂದ್ರಿತ ಎಂಜಿನಿಯರಿಂಗ್",
      aboutCheck4: "ವಿಶ್ವಾಸಾರ್ಹ ಉತ್ಪಾದನೆ",
      aboutEst: "ಸ್ಥಾಪನೆ ೧೯೮೯",
      aboutLegacy: "೩೫+ ವರ್ಷಗಳ ಪರಂಪರೆ",
      aboutFounderTag: "ಸಂಸ್ಥಾಪಕರನ್ನು ಭೇಟಿಯಾಗಿ",
      aboutFounderTitle: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್‌ನ ನಾಯಕತ್ವ",
      aboutFounderQuote: "\"ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್‌ನಲ್ಲಿ, ನಮ್ಮ ದೃಷ್ಟಿಕೋನವು ಯಾವಾಗಲೂ ನವೀನ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ನಿರ್ಮಿಸುವುದಾಗಿದ್ದು, ರೈತರು ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಉದ್ಯಮಗಳು ಸುಸ್ಥಿರ ಬೆಳವಣಿಗೆಯನ್ನು ಸಾಧಿಸಲು ನೆರವಾಗುತ್ತದೆ.\"",
      aboutFounderBio: "೧೯೮೯ ರಿಂದ ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ನಿಖರವಾದ ಎಂಜಿನಿಯರಿಂಗ್, ಗುಣಮಟ್ಟದ ಕುಶಲತೆ ಮತ್ತು ಗ್ರಾಹಕ-ಕೇಂದ್ರಿತ ನಾವೀನ್ಯತೆಯೊಂದಿಗೆ ವಿಶ್ವಾಸಾರ್ಹ ಕೃಷಿ ಉಪಕರಣಗಳನ್ನು ತಯಾರಿಸಲು ಬದ್ಧವಾಗಿದೆ.",
      aboutFounderBadge: "೧೯೮೯ ರಿಂದ ಉತ್ಪಾದನಾ ಶ್ರೇಷ್ಠತೆ",
      aboutAchieve1: "ಕೃಷಿ ಯಂತ್ರೋಪಕರಣ ತಜ್ಞರು",
      aboutAchieve2: "ಆಹಾರ ಸಂಸ್ಕರಣಾ ಪರಿಹಾರಗಳು",
      aboutAchieve3: "ನಿಖರ ಎಂಜಿನಿಯರಿಂಗ್ ಶ್ರೇಷ್ಠತೆ",
      aboutAchieve4: "ಗ್ರಾಹಕ-ಕೇಂದ್ರಿತ ನಾವೀನ್ಯತೆ",
      aboutVmTag: "ನಮ್ಮ ಮೌಲ್ಯಗಳು",
      aboutVmTitle: "ದೃಷ್ಟಿಕೋನ ಮತ್ತು ಧ್ಯೇಯ",
      aboutVisionTitle: "ನಮ್ಮ ದೃಷ್ಟಿಕೋನ (Vision)",
      aboutVisionDesc: "ನಾವೀನ್ಯತೆ, ಗುಣಮಟ್ಟದ ಎಂಜಿನಿಯರಿಂಗ್ ಮತ್ತು ಸುಸ್ಥಿರ ಉತ್ಪಾದನೆಯ ಮೂಲಕ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳ ಜಾಗತಿಕ ತಯಾರಕರಾಗುವುದು.",
      aboutVision1: "ನವೀನ ಕೃಷಿ ಯಂತ್ರೋಪಕರಣ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುವುದು",
      aboutVision2: "ರೈತರು ಮತ್ತು ಸಂಸ್ಕರಣಾ ಉದ್ಯಮಗಳನ್ನು ಸಬಲೀಕರಣಗೊಳಿಸುವುದು",
      aboutVision3: "ವಿಶ್ವಾಸಾರ್ಹ, ಉನ್ನತ ಕಾರ್ಯಕ್ಷಮತೆಯ ಯಂತ್ರಗಳನ್ನು ತಯಾರಿಸುವುದು",
      aboutVision4: "ಗುಣಮಟ್ಟ ಮತ್ತು ಗ್ರಾಹಕರ ನಂಬಿಕೆಯೊಂದಿಗೆ ವಿಸ್ತರಿಸುವುದು",
      aboutMissionTitle: "ನಮ್ಮ ಧ್ಯೇಯ (Mission)",
      aboutMissionDesc: "ಉತ್ಪಾದಕತೆಯನ್ನು ಸುಧಾರಿಸುವ, ಶ್ರಮವನ್ನು ಕಡಿಮೆ ಮಾಡುವ ಮತ್ತು ನಿರಂತರ ಗ್ರಾಹಕ ಬೆಂಬಲದೊಂದಿಗೆ ದೀರ್ಘಕಾಲೀನ ಮೌಲ್ಯವನ್ನು ನೀಡುವ ಸಮರ್ಥ ಯಂತ್ರಗಳನ್ನು ವಿನ್ಯಾಸಗೊಳಿಸುವುದು.",
      aboutMission1: "ನಿಖರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ನಿರ್ಮಿಸುವುದು",
      aboutMission2: "ಉತ್ತಮ ಗುಣಮಟ್ಟ ಮತ್ತು ತಾಂತ್ರಿಕ ಬೆಂಬಲವನ್ನು ಒದಗಿಸುವುದು",
      aboutMission3: "ದಕ್ಷ ಮತ್ತು ಕಸ್ಟಮೈಸ್ ಮಾಡಿದ ಯಂತ್ರ ಪರಿಹಾರಗಳನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸುವುದು",
      aboutMission4: "ದೀರ್ಘಕಾಲೀನ ಗ್ರಾಹಕ ತೃಪ್ತಿಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳುವುದು",
      aboutValuesTag: "ಮಾರ್ಗದರ್ಶಿ ತತ್ವಗಳು",
      aboutValuesTitle: "ನಮ್ಮ ಮೂಲ ಮೌಲ್ಯಗಳು",
      valIntegrity: "ಪ್ರಾಮಾಣಿಕತೆ ಮತ್ತು ನಿಷ್ಠೆ",
      valIntegrityDesc: "ಪ್ರಾಮಾಣಿಕತೆ, ಗುಣಮಟ್ಟದ ಕುಶಲತೆ ಮತ್ತು ಜವಾಬ್ದಾರಿಯುತ ವ್ಯಾಪಾರದ ಮೂಲಕ ನಾವು ನಂಬಿಕೆಯನ್ನು ಬೆಳೆಸುತ್ತೇವೆ.",
      valInnovation: "ನಾವೀನ್ಯತೆ",
      valInnovationDesc: "ಪ್ರಾಯೋಗಿಕ ಎಂಜಿನಿಯರಿಂಗ್ ಮತ್ತು ಸುಧಾರಿತ ಉತ್ಪಾದನೆಯೊಂದಿಗೆ ನಾವು ನಮ್ಮ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ನಿರಂತರವಾಗಿ ಸುಧಾರಿಸುತ್ತೇವೆ.",
      valCustomerFirst: "ಗ್ರಾಹಕರಿಗೆ ಆದ್ಯತೆ",
      valCustomerFirstDesc: "ಪ್ರತಿಯೊಂದು ಪರಿಹಾರವನ್ನು ಗ್ರಾಹಕರ ಅಗತ್ಯತೆಗಳು ಮತ್ತು ದೀರ್ಘಕಾಲೀನ ತೃಪ್ತಿಯ ಸುತ್ತ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.",
      valQuality: "ಉತ್ತಮ ಗುಣಮಟ್ಟ",
      valQualityDesc: "ಗ್ರಾಹಕರನ್ನು ತಲುಪುವ ಮೊದಲು ಪ್ರತಿಯೊಂದು ಯಂತ್ರವು ಕಟ್ಟುನಿಟ್ಟಾದ ಗುಣಮಟ್ಟದ ಪರಿಶೀಲನೆಗೆ ಒಳಗಾಗುತ್ತದೆ.",
      valExpertise: "ಎಂಜಿನಿಯರಿಂಗ್ ಪರಿಣತಿ",
      valExpertiseDesc: "ನಮ್ಮ ಅನುಭವಿ ತಂಡವು ಆಧುನಿಕ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣೆಗಾಗಿ ವಿಶ್ವಾಸಾರ್ಹ ಯಂತ್ರಗಳನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸುತ್ತದೆ.",
      valGrowth: "ಸುಸ್ಥಿರ ಬೆಳವಣಿಗೆ",
      valGrowthDesc: "ನಾವು ಉತ್ಪಾದಕತೆಯನ್ನು ಹೆಚ್ಚಿಸುವ ಮತ್ತು ಪರಿಸರಸ್ನೇಹಿ ಉತ್ಪಾದನೆಯನ್ನು ಬೆಂಬಲಿಸುವ ಸಮರ್ಥ ಯಂತ್ರಗಳನ್ನು ತಯಾರಿಸುತ್ತೇವೆ.",
      aboutInfraTag: "ನಮ್ಮ ಕಾರ್ಖಾನೆ",
      aboutInfraTitle1: "ಸುಧಾರಿತ ಉತ್ಪಾದನಾ",
      aboutInfraTitle2: "ಮೂಲಸೌಕರ್ಯ",
      aboutInfraP1: "ನಮ್ಮ ಆಧುನಿಕ ಉತ್ಪಾದನಾ ಘಟಕವು ಸುಧಾರಿತ ಫ್ಯಾಬ್ರಿಕೇಶನ್, ಮೆಷಿನಿಂಗ್, ಜೋಡಣೆ ಮತ್ತು ಗುಣಮಟ್ಟ ಪರಿಶೀಲನಾ ವ್ಯವಸ್ಥೆಗಳನ್ನು ಹೊಂದಿದೆ.",
      aboutInfraP2: "ಸ್ಥಿರ ಗುಣಮಟ್ಟ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಪ್ರತಿಯೊಂದು ಉತ್ಪಾದನಾ ಹಂತವನ್ನು ನುರಿತ ವೃತ್ತಿಪರರು ನಿರ್ವಹಿಸುತ್ತಾರೆ.",
      aboutInfraStat1Title: "ಸುಧಾರಿತ ಉತ್ಪಾದನೆ",
      aboutInfraStat1Sub: "ನಿಖರ ಎಂಜಿನಿಯರಿಂಗ್",
      aboutInfraStat2Title: "ಗುಣಮಟ್ಟ ತಪಾಸಣೆ",
      aboutInfraStat2Sub: "ವಿಶ್ವಾಸಾರ್ಹ ಕಾರ್ಯಾಚರಣೆ",
      aboutInfraStat3Title: "ಗ್ರಾಹಕ ಬೆಂಬಲ",
      aboutInfraStat3Sub: "ಸಂಪೂರ್ಣ ನೆರವು",

      // ─── PRODUCTS PAGE ───
      productsBadge: "ಉತ್ಪನ್ನಗಳ ಶ್ರೇಣಿ",
      productsTitle1: "ನಮ್ಮ",
      productsTitle2: "ಉತ್ಪನ್ನಗಳು",
      productsSubtitle: "ದಕ್ಷ ಕಾರ್ಯಾಚರಣೆಗಾಗಿ ನಿಖರವಾಗಿ ನಿರ್ಮಿಸಲಾದ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳು.",
      catAll: "ಎಲ್ಲಾ",
      catBedana: "ಒಣದ್ರಾಕ್ಷಿ ಸಂಸ್ಕರಣೆ",
      catWashing: "ತೊಳೆಯುವುದು ಮತ್ತು ಸ್ವಚ್ಛಗೊಳಿಸುವಿಕೆ",
      catGrading: "ಗ್ರೇಡಿಂಗ್ ಮತ್ತು ವಿಂಗಡಣೆ",
      catConveyor: "ಕನ್ವೇಯರ್ ಮತ್ತು ಹ್ಯಾಂಡ್ಲಿಂಗ್",
      catCustom: "ಕಸ್ಟಮ್ ಉಪಕರಣಗಳು",
      catFoodProcessing: "ಆಹಾರ ಸಂಸ್ಕರಣೆ",
      catIndustrial: "ಕೈಗಾರಿಕಾ ಉಪಕರಣಗಳು",
      catAgri: "ಕೃಷಿ ಯಂತ್ರೋಪಕರಣಗಳು",
      prodCapacity: "ಸಾಮರ್ಥ್ಯ:",
      btnViewDetail: "ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
      noProductsFound: "ಈ ವಿಭಾಗದಲ್ಲಿ ಯಾವುದೇ ಉತ್ಪನ್ನಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
      loadingText: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",

      // ─── PRODUCT DETAIL PAGE ───
      bcHome: "ಮುಖಪುಟ",
      bcProducts: "ಉತ್ಪನ್ನಗಳು",
      bcAllProducts: "ಎಲ್ಲಾ ಉತ್ಪನ್ನಗಳು",
      zoomHint: "ಪೂರ್ಣ ನೋಟ ಮತ್ತು ಜೂಮ್ ಮಾಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
      pdKeyFeatures: "ಪ್ರಮುಖ ವೈಶಿಷ್ಟ್ಯಗಳು",
      pdProductOverview: "ಉತ್ಪನ್ನದ ಅವಲೋಕನ",
      pdDetailedSpecs: "ವಿವರವಾದ ವಿಶೇಷಣಗಳು",
      pdBtnEnquire: "ಈಗಲೇ ವಿಚಾರಿಸಿ",
      pdBtnWhatsApp: "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ತ್ವರಿತ ಚಾಟ್",
      pdQuoteBadge: "ನೇರ ಕಾರ್ಖಾನೆ ಸಮಾಲೋಚನೆ",
      pdQuoteTitle: "ಸಮಾಲೋಚನೆ ಮತ್ತು ಉಲ್ಲೇಖವನ್ನು ವಿನಂತಿಸಿ",
      pdQuoteDesc: "ತಾಂತ್ರಿಕ ಸಮಾಲೋಚನೆ, ಕಸ್ಟಮ್ ಕಾನ್ಫಿಗರೇಶನ್‌ಗಳು ಮತ್ತು ಕಾರ್ಖಾನೆಯ ದರ ವಿವರಗಳಿಗಾಗಿ ಕೆಳಗಿನ ಫಾರ್ಮ್ ಭರ್ತಿ ಮಾಡಿ.",
      pdQuoteSpecificDesc: "{{name}} ನಲ್ಲಿ ಆಸಕ್ತಿ ಇದೆಯೇ? ತಾಂತ್ರಿಕ ಸಮಾಲೋಚನೆ, ಕಸ್ಟಮ್ ಕಾನ್ಫಿಗರೇಶನ್‌ಗಳು ಮತ್ತು ಕಾರ್ಖಾನೆಯ ದರ ವಿವರಗಳಿಗಾಗಿ ಕೆಳಗಿನ ಫಾರ್ಮ್ ಭರ್ತಿ ಮಾಡಿ.",
      pdBedanaOverview: "{{name}} ಹೆಚ್ಚಿನ ಉತ್ಪಾದಕತೆ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಕೈಗಾರಿಕಾ ಕಾರ್ಯಕ್ಷಮತೆಯೊಂದಿಗೆ ಬೃಹತ್ ಪ್ರಮಾಣದ ಒಣದ್ರಾಕ್ಷಿ (ಬೆದಾನ) ಸಂಸ್ಕರಣೆಗಾಗಿ ವಿಶೇಷವಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ಇದು ಗುಣಮಟ್ಟವನ್ನು ಸ್ಥಿರವಾಗಿ ಕಾಪಾಡಿಕೊಂಡು ನಿರಂತರ ಉತ್ಪಾದನೆಯನ್ನು ನೀಡುತ್ತದೆ. ಹೆವಿ-ಡ್ಯೂಟಿ ಬಳಕೆಗಾಗಿ ನಿರ್ಮಿಸಲಾದ ಇದು ವಾಣಿಜ್ಯ ಆಹಾರ ಸಂಸ್ಕರಣಾ ಕೈಗಾರಿಕೆಗಳಿಗೆ ಅತ್ಯಂತ ಸೂಕ್ತವಾಗಿದೆ.",
      pdBedanaShortDesc: "ಸ್ಥಿರ ಗುಣಮಟ್ಟದೊಂದಿಗೆ ಹೆಚ್ಚಿನ ಸಾಮರ್ಥ್ಯದ ಒಣದ್ರಾಕ್ಷಿ (ಬೆದಾನ) ಸ್ವಚ್ಛಗೊಳಿಸುವಿಕೆ, ತೊಳೆಯುವುದು ಮತ್ತು ಸಂಸ್ಕರಣೆಗಾಗಿ ಸುಧಾರಿತ ಯಂತ್ರೋಪಕರಣ.",
      pdBedanaSpec1: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್‌ನ {{name}} ವಾಣಿಜ್ಯ ಒಣದ್ರಾಕ್ಷಿ ಉತ್ಪಾದನೆ ಮತ್ತು ಡ್ರೈ ಫ್ರೂಟ್ಸ್ ಸಂಸ್ಕರಣಾ ಕೈಗಾರಿಕೆಗಳ ಬೆಳೆಯುತ್ತಿರುವ ಬೇಡಿಕೆಗಳನ್ನು ಪೂರೈಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ಹೆವಿ-ಡ್ಯೂಟಿ ಕೈಗಾರಿಕಾ ಫ್ಯಾಬ್ರಿಕೇಶನ್‌ನೊಂದಿಗೆ ನಿರ್ಮಿಸಲಾದ ಈ ಯಂತ್ರವು ಹೆಚ್ಚಿನ ಸಂಸ್ಕರಣಾ ದಕ್ಷತೆ, ಸ್ಥಿರ ಉತ್ಪಾದನಾ ಗುಣಮಟ್ಟ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ದೀರ್ಘಾವಧಿಯ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ನೀಡುತ್ತದೆ. ಇದರ ದೃಢವಾದ ವಿನ್ಯಾಸವು ದೈಹಿಕ ಶ್ರಮವನ್ನು ಕಡಿಮೆ ಮಾಡಿ ಒಟ್ಟಾರೆ ಉತ್ಪಾದನೆಯನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ.",
      pdBedanaSpec2: "ಪ್ರೀಮಿಯಂ ಎಂಜಿನಿಯರಿಂಗ್ ಮಾನದಂಡಗಳೊಂದಿಗೆ ತಯಾರಿಸಲಾದ ಈ ಯಂತ್ರವು ಸುಗಮ ಸಂಸ್ಕರಣೆ, ಕಡಿಮೆ ನಿರ್ವಹಣೆ ಮತ್ತು ಶಕ್ತಿ-ದಕ್ಷ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಖಚಿತಪಡಿಸುತ್ತದೆ, ಇದು ಆಧುನಿಕ ಆಹಾರ ಸಂಸ್ಕರಣಾ ಸೌಲಭ್ಯಗಳಿಗೆ ಅತ್ಯುತ್ತಮ ಹೂಡಿಕೆಯಾಗಿದೆ.",
      pdBedanaSpec3: "ಈ ಯಂತ್ರವು ಹೆವಿ-ಡ್ಯೂಟಿ ನಿರ್ಮಾಣ, ಹೆಚ್ಚಿನ ಸಂಸ್ಕರಣಾ ಸಾಮರ್ಥ್ಯ, ನಿರಂತರ ಉತ್ಪಾದನಾ ವ್ಯವಸ್ಥೆ, ವಿಶ್ವಾಸಾರ್ಹ ಕೈಗಾರಿಕಾ ಕಾರ್ಯಕ್ಷಮತೆ, ಸುಲಭ ನಿರ್ವಹಣೆ, ಶಕ್ತಿ ಉಳಿತಾಯದ ಕಾರ್ಯಾಚರಣೆ, ಬಳಕೆದಾರ ಸ್ನೇಹಿ ನಿಯಂತ್ರಣಗಳು ಮತ್ತು ದೀರ್ಘಾವಧಿ ಬಾಳಿಕೆಯನ್ನು ಒಳಗೊಂಡಿದೆ.",
      pdBedanaSpec4: "ಇದು ಒಣದ್ರಾಕ್ಷಿ ಉತ್ಪಾದನಾ ಘಟಕಗಳು, ಒಣ ಹಣ್ಣುಗಳ ಸಂಸ್ಕರಣಾ ಕೈಗಾರಿಕೆಗಳು, ಆಹಾರ ಸಂಸ್ಕರಣಾ ಕಂಪನಿಗಳು, ಕೃಷಿ ಸಂಸ್ಕರಣಾ ಘಟಕಗಳು ಮತ್ತು ದೊಡ್ಡ ಪ್ರಮಾಣದ ಉತ್ಪಾದನೆ ಅಗತ್ಯವಿರುವ ರಫ್ತು ಆಧಾರಿತ ಆಹಾರ ಕೈಗಾರಿಕೆಗಳಿಗೆ ಅತ್ಯಂತ ಸೂಕ್ತವಾಗಿದೆ.",
      pdGeneralOverview: "{{name}} ಕೈಗಾರಿಕಾ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣೆಗಾಗಿ ಹೆಚ್ಚಿನ ಉತ್ಪಾದಕತೆ, ನಿಖರವಾದ ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ದೀರ್ಘ ಕಾರ್ಯಾಚರಣೆಯ ಜೀವಿತಾವಧಿಯೊಂದಿಗೆ ವಿಶೇಷವಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.",
      pdGeneralSpec1: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್‌ನ {{name}} ಕೈಗಾರಿಕಾ ದರ್ಜೆಯ ಮಾನದಂಡಗಳನ್ನು ಪೂರೈಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದ್ದು, ಹೆಚ್ಚಿನ ಸಂಸ್ಕರಣಾ ದಕ್ಷತೆ ಮತ್ತು ಬಾಳಿಕೆ ಬರುವ ನಿರ್ಮಾಣವನ್ನು ನೀಡುತ್ತದೆ.",
      pdGeneralSpec2: "ಪ್ರೀಮಿಯಂ ಎಂಜಿನಿಯರಿಂಗ್ ಮಾನದಂಡಗಳೊಂದಿಗೆ ತಯಾರಿಸಲಾದ ಈ ಯಂತ್ರವು ಆಧುನಿಕ ಕೈಗಾರಿಕಾ ಸೌಲಭ್ಯಗಳಿಗೆ ಸುಗಮ ಸಂಸ್ಕರಣೆ, ಕಡಿಮೆ ನಿರ್ವಹಣೆ ಮತ್ತು ಶಕ್ತಿ-ದಕ್ಷ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಖಚಿತಪಡಿಸುತ್ತದೆ.",
      pdGeneralSpec3: "ದೈನಂದಿನ ಕಾರ್ಖಾನೆಯ ಕಠಿಣ ಕೆಲಸದ ಹೊರೆಯನ್ನು ನಿಭಾಯಿಸಲು ಈ ಯಂತ್ರವನ್ನು ದೃಢವಾದ ವಸ್ತುಗಳು, ಬಳಕೆದಾರ ಸ್ನೇಹಿ ನಿಯಂತ್ರಣಗಳು ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಸುರಕ್ಷತಾ ಕಾರ್ಯವಿಧಾನಗಳೊಂದಿಗೆ ನಿರ್ಮಿಸಲಾಗಿದೆ.",
      pdNotFoundTitle: "ಉತ್ಪನ್ನ ಕಂಡುಬಂದಿಲ್ಲ",
      pdNotFoundDesc: "ನೀವು ಹುಡುಕುತ್ತಿರುವ ಯಂತ್ರೋಪಕರಣವು ನವೀಕರಿಸಲ್ಪಟ್ಟಿದೆ ಅಥವಾ ಲಭ್ಯವಿಲ್ಲ.",
      pdBackToCatalog: "ಉತ್ಪನ್ನ ಕ್ಯಾಟಲಾಗ್‌ಗೆ ಹಿಂತಿರುಗಿ",
      featCustomSolutions: "ಕಸ್ಟಮ್ ಕೈಗಾರಿಕಾ ಪರಿಹಾರಗಳು",
      featStainlessSteel: "SS304 ಸ್ಟೇನ್‌ಲೆಸ್ ಸ್ಟೀಲ್ ಮತ್ತು M.S. ನಲ್ಲಿ ತಯಾರಿಸಲಾಗಿದೆ",
      featHeavyDuty: "ಭಾರೀ ಕರ್ತವ್ಯದ ಕೈಗಾರಿಕಾ ನಿರ್ಮಾಣ",
      featHighPerf: "ಹೆಚ್ಚಿನ ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ನಿರಂತರ ಉತ್ಪಾದನೆ",
      featEnergySaving: "ಶಕ್ತಿ ಉಳಿತಾಯ ಮತ್ತು ವೆಚ್ಚ-ಪರಿಣಾಮಕಾರಿ ಕಾರ್ಯಾಚರಣೆ",
      featLowMaint: "ಕಡಿಮೆ ನಿರ್ವಹಣೆ ಮತ್ತು ದೀರ್ಘಾವಧಿ ಬಾಳಿಕೆ",
      formPhonePlaceholder: "ಉದಾ. ೯೮೭೬೫೪೩೨೧೦",
      formEmailPlaceholder: "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",

      // ─── SERVICES PAGE ───
      servicesBadge: "ನಾವು ನೀಡುವುದು",
      servicesTitle1: "ನಮ್ಮ",
      servicesTitle2: "ಸೇವೆಗಳು",
      servicesSubtitle: "ಅಳವಡಿಕೆ ಮತ್ತು ಕಮಿಷನಿಂಗ್‌ನಿಂದ ಹಿಡಿದು ನಿರ್ವಹಣೆ, ತಾಂತ್ರಿಕ ಬೆಂಬಲ ಮತ್ತು ಕಸ್ಟಮ್ ಎಂಜಿನಿಯರಿಂಗ್‌ವರೆಗೆ ನಾವು ವಿಶ್ವಾಸಾರ್ಹ ಸೇವೆಗಳನ್ನು ನೀಡುತ್ತೇವೆ.",
      svcInstallTitle: "ಅಳವಡಿಕೆ ಮತ್ತು ಕಮಿಷನಿಂಗ್",
      svcInstallDesc: "ಸುಗಮ ಆರಂಭ ಮತ್ತು ಸುಲಭ ಕಾರ್ಯವೈಖರಿಗಾಗಿ ತಜ್ಞರಿಂದ ಆನ್-ಸೈಟ್ ಅಳವಡಿಕೆ ಮತ್ತು ಟ್ರಯಲ್ ರನ್.",
      svcMaintTitle: "ಮುನ್ನೆಚ್ಚರಿಕೆ ನಿರ್ವಹಣೆ",
      svcMaintDesc: "ಯಂತ್ರವು ನಿಲ್ಲದೆ ದೀರ್ಘಕಾಲ ಕಾರ್ಯನಿರ್ವಹಿಸಲು ನಿಯಮಿತ ತಪಾಸಣೆ ಮತ್ತು ನಿಗದಿತ ಸರ್ವಿಸ್.",
      svcPartsTitle: "ಅಸಲಿ ಬಿಡಿಭಾಗಗಳು (Spare Parts)",
      svcPartsDesc: "ಉತ್ಪಾದನೆಗೆ ಅಡ್ಡಿಯಾಗದಂತೆ ನಿಖರವಾಗಿ ತಯಾರಿಸಿದ ಅಧಿಕೃತ ಬಿಡಿಭಾಗಗಳ ತ್ವರಿತ ಪೂರೈಕೆ.",
      svcTrainingTitle: "ಆಪರೇಟರ್ ತರಬೇತಿ",
      svcTrainingDesc: "ಉತ್ಪಾದನೆ ಮತ್ತು ಸುರಕ್ಷತೆಯನ್ನು ಹೆಚ್ಚಿಸಲು ನಿಮ್ಮ ಸಿಬ್ಬಂದಿಗೆ ಸಮಗ್ರ ಕಾರ್ಯಾಚರಣಾ ತರಬೇತಿ.",
      svcCustomTitle: "ಕಸ್ಟಮ್ ಎಂಜಿನಿಯರಿಂಗ್",
      svcCustomDesc: "ನಿಮ್ಮ ಕಾರ್ಖಾನೆಯ ಅಗತ್ಯತೆಗಳು ಮತ್ತು ಸ್ಥಳಾವಕಾಶಕ್ಕೆ ತಕ್ಕಂತೆ ಕಸ್ಟಮ್ ಯಂತ್ರ ವಿನ್ಯಾಸ.",
      svcSupportTitle: "೨೪/೭ ತಾಂತ್ರಿಕ ಬೆಂಬಲ",
      svcSupportDesc: "ತಾಂತ್ರಿಕ ಸಮಸ್ಯೆಗಳನ್ನು ತ್ವರಿತವಾಗಿ ಪರಿಹರಿಸಲು ಫೋನ್, ವೀಡಿಯೊ ಮತ್ತು ಆನ್-ಸೈಟ್ ಇಂಜಿನಿಯರಿಂಗ್ ನೆರವು.",
      svcConveyorTitle: "ಕನ್ವೇಯರ್ ಮತ್ತು ಮೆಟೀರಿಯಲ್ ಹ್ಯಾಂಡ್ಲಿಂಗ್ ಪರಿಹಾರಗಳು",
      svcConveyorDesc: "ಕಚ್ಚಾ ವಸ್ತುಗಳು ಮತ್ತು ಸಿದ್ಧ ಉತ್ಪನ್ನಗಳ ಸುಗಮ ಚಲನೆಗಾಗಿ ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಕಸ್ಟಮ್ ಕನ್ವೇಯರ್ ಮತ್ತು ಮೆಟೀರಿಯಲ್ ಹ್ಯಾಂಡ್ಲಿಂಗ್ ಪರಿಹಾರಗಳನ್ನು ಒದಗಿಸುತ್ತದೆ.",
      svcExportTitle: "ರಫ್ತು ಮತ್ತು ಲಾಜಿಸ್ಟಿಕ್ಸ್ ಪರಿಹಾರಗಳು",
      svcExportDesc: "ಸುರಕ್ಷಿತ ಪ್ಯಾಕೇಜಿಂಗ್, ಸಾಗಣೆ ಸಮನ್ವಯ, ರಫ್ತು ದಾಖಲಾತಿ ಮತ್ತು ಸಮಯೋಚಿತ ಅಂತರರಾಷ್ಟ್ರೀಯ ವಿತರಣೆಯೊಂದಿಗೆ ಯಂತ್ರೋಪಕರಣಗಳಿಗೆ ವಿಶ್ವಾಸಾರ್ಹ ರಫ್ತು ಬೆಂಬಲ.",
      svcConsultTitle: "ತಾಂತ್ರಿಕ ಸಮಾಲೋಚನೆ ಮತ್ತು ಯೋಜನೆ ಬೆಂಬಲ",
      svcConsultDesc: "ಉತ್ಪಾದಕತೆಯನ್ನು ಗರಿಷ್ಠಗೊಳಿಸಲು ಸರಿಯಾದ ಯಂತ್ರೋಪಕರಣಗಳ ಆಯ್ಕೆ, ಪ್ರೊಸೆಸಿಂಗ್ ಲೈನ್ ವಿನ್ಯಾಸ ಮತ್ತು ಕಸ್ಟಮ್ ಆಟೋಮೇಷನ್ ಕುರಿತು ವೃತ್ತಿಪರ ಮಾರ್ಗದರ್ಶನ.",
      catMaterialHandling: "ಮೆಟೀರಿಯಲ್ ಹ್ಯಾಂಡ್ಲಿಂಗ್",
      catAirHandling: "ಏರ್ ಹ್ಯಾಂಡ್ಲಿಂಗ್",
      catHeatingSystems: "ಹೀಟಿಂಗ್ ಸಿಸ್ಟಮ್ಸ್",

      // ─── CONTACT PAGE ───
      contactBadge: "ಸಂಪರ್ಕದಲ್ಲಿರಿ",
      contactTitle1: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಅನ್ನು",
      contactTitle2: "ಸಂಪರ್ಕಿಸಿ",
      contactSubtitle: "ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳು, ಉತ್ಪನ್ನ ವಿಚಾರಣೆ ಅಥವಾ ತಾಂತ್ರಿಕ ಬೆಂಬಲಕ್ಕಾಗಿ ನಮ್ಮ ತಜ್ಞರೊಂದಿಗೆ ಮಾತನಾಡಿ.",
      contactDirectComm: "ನೇರ ಸಂವಹನ",
      contactInfoTitle: "ಸಂಪರ್ಕ ಮಾಹಿತಿ",
      contactInfoSubtitle: "ಯಂತ್ರೋಪಕರಣ ವಿಚಾರಣೆ, ಕಸ್ಟಮ್ ಪ್ರಕ್ರಿಯೆ ಪರಿಹಾರಗಳು ಅಥವಾ ತಾಂತ್ರಿಕ ನೆರವಿಗಾಗಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.",
      contactAddressLabel: "ಕಾರ್ಖಾನೆ ಮತ್ತು ಕಚೇರಿ ವಿಳಾಸ",
      contactPhoneLabel: "ದೂರವಾಣಿ ಬೆಂಬಲ",
      contactEmailLabel: "ಇಮೇಲ್ ವಿಳಾಸ",
      tabGeneralInquiry: "ಸಾಮಾನ್ಯ ವಿಚಾರಣೆ",
      tabCareerApp: "ಉದ್ಯೋಗ ಅರ್ಜಿ",
      formFullName: "ಪೂರ್ಣ ಹೆಸರು",
      formEnterFullName: "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
      formEmail: "ಇಮೇಲ್ ವಿಳಾಸ",
      formPhone: "ಫೋನ್ ಸಂಖ್ಯೆ",
      formEnterPhone: "ನಿಮ್ಮ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
      formMessage: "ಸಂದೇಶ",
      formMessagePlaceholder: "ನಿಮ್ಮ ವಿಚಾರಣೆ ಅಥವಾ ಯಂತ್ರೋಪಕರಣದ ಅಗತ್ಯವನ್ನು ಇಲ್ಲಿ ಬರೆಯಿರಿ...",
      formSendMessage: "ಸಂದೇಶ ಕಳುಹಿಸಿ",
      formSending: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...",
      formMsgSuccess: "ಸಂದೇಶವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಕಳುಹಿಸಲಾಗಿದೆ!",
      formPosition: "ಅರ್ಜಿ ಸಲ್ಲಿಸುತ್ತಿರುವ ಹುದ್ದೆ",
      formSelectPosition: "ಹುದ್ದೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
      posMechEng: "ಮೆಕ್ಯಾನಿಕಲ್ ಇಂಜಿನಿಯರ್",
      posTech: "ತಂತ್ರಜ್ಞ (Technician)",
      posSales: "ಸೇಲ್ಸ್ ಎಕ್ಸಿಕ್ಯೂಟಿವ್",
      posOther: "ಇತರೆ",
      formExperience: "ಅನುಭವದ ವರ್ಷಗಳು",
      formUploadResume: "ರೆಸ್ಯೂಮ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ (PDF/DOC, ಗರಿಷ್ಠ 700KB)",
      formSubmitApp: "ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
      formSubmitting: "ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...",
      formAppSuccess: "ಅರ್ಜಿಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ!",
      contactMapTitle: "ನಕ್ಷೆಯಲ್ಲಿ ನಮ್ಮನ್ನು ಹುಡುಕಿ",
      alertMissingTitle: "ಅಪೂರ್ಣ ವಿವರಗಳು",
      alertMissingText: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.",
      alertSuccessTitle: "ವಿನಂತಿಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಕಳುಹಿಸಲಾಗಿದೆ!",
      alertSuccessText: "ನಿಮ್ಮ ಆಸಕ್ತಿಗೆ ಧನ್ಯವಾದಗಳು. ನಮ್ಮ ತಾಂತ್ರಿಕ ತಂಡವು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ.",
      alertErrorTitle: "ಸಲ್ಲಿಕೆ ವಿಫಲವಾಗಿದೆ",
      alertErrorText: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಫೋನ್ ಅಥವಾ ವಾಟ್ಸಾಪ್ ಮೂಲಕ ಸಂಪರ್ಕಿಸಿ.",

      // ─── FAQ PAGE ───
      faqBadge: "ಸಹಾಯ ಕೇಂದ್ರ",
      faqTitle1: "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ",
      faqTitle2: "ಪ್ರಶ್ನೆಗಳು (FAQ)",
      faqSubtitle: "ನಮ್ಮ ಉತ್ಪನ್ನಗಳು, ಸೇವೆಗಳು ಮತ್ತು ಕಂಪನಿಯ ಬಗ್ಗೆ ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಗಳನ್ನು ಹುಡುಕಿ.",
      faqNoFaqs: "ಈ ವಿಭಾಗದಲ್ಲಿ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಲಭ್ಯವಿಲ್ಲ.",
      faqStillQuestions: "ಇನ್ನೂ ಪ್ರಶ್ನೆಗಳಿವೆಯೇ?",
      faqStillQuestionsDesc: "ನೀವು ಹುಡುಕುತ್ತಿರುವ ಉತ್ತರ ಸಿಗಲಿಲ್ಲವೇ? ನೇರವಾಗಿ ನಮ್ಮ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",
      faqContactBtn: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
      faqQ1: "ಒಣದ್ರಾಕ್ಷಿ (ಬೇಡಾನಾ) ಸಂಸ್ಕರಣಾ ಯಂತ್ರದ ಸಾಮರ್ಥ್ಯ ಎಷ್ಟು?",
      faqA1: "ನಮ್ಮ ಒಣದ್ರಾಕ್ಷಿ ಸಂಸ್ಕರಣಾ ಯಂತ್ರವು ಗಂಟೆಗೆ ೧ ರಿಂದ ೪ ಟನ್ ಸಾಮರ್ಥ್ಯವನ್ನು ನೀಡುತ್ತದೆ ಮತ್ತು ಕನಿಷ್ಠ ಶ್ರಮದಲ್ಲಿ ನಿರಂತರ ಕಾರ್ಯಾಚರಣೆಗೆ ಸೂಕ್ತವಾಗಿದೆ.",
      faqQ2: "ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ತಯಾರಿಸಲು ಯಾವ ವಸ್ತುಗಳನ್ನು ಬಳಸಲಾಗುತ್ತದೆ?",
      faqA2: "ಆಹಾರದ ಸಂಪರ್ಕಕ್ಕೆ ಬರುವ ಎಲ್ಲಾ ಭಾಗಗಳನ್ನು ಪ್ರೀಮಿಯಂ ಫುಡ್-ಗ್ರೇಡ್ SS304 ಸ್ಟೇನ್‌ಲೆಸ್ ಸ್ಟೀಲ್ ಮತ್ತು ಬಾಳಿಕೆ ಬರುವ ಮೈಲ್ಡ್ ಸ್ಟೀಲ್‌ನಿಂದ ತಯಾರಿಸಲಾಗುತ್ತದೆ.",
      faqQ3: "ನೀವು ಸ್ಥಳದಲ್ಲೇ ಅಳವಡಿಕೆ ಮತ್ತು ಆಪರೇಟರ್ ತರಬೇತಿ ನೀಡುತ್ತೀರಾ?",
      faqA3: "ಹೌದು, ನಮ್ಮ ಅನುಭವಿ ಎಂಜಿನಿಯರಿಂಗ್ ತಂಡವು ಆನ್-ಸೈಟ್ ಅಳವಡಿಕೆ, ಟ್ರಯಲ್ ರನ್ ಮತ್ತು ಸಿಬ್ಬಂದಿಗೆ ಸಂಪೂರ್ಣ ಕಾರ್ಯಾಚರಣಾ ತರಬೇತಿಯನ್ನು ನೀಡುತ್ತದೆ.",
      faqQ4: "ನೀವು ಭಾರತದ ಹೊರಗೆ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ರಫ್ತು ಮಾಡುತ್ತೀರಾ?",
      faqA4: "ಹೌದು, ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ವಿಶ್ವದ ೧೨ ಕ್ಕೂ ಹೆಚ್ಚು ದೇಶಗಳಿಗೆ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ರಫ್ತು ಮಾಡಿದೆ.",

      // ─── BLOGS & BLOG POST PAGE ───
      blogsBadge: "ಮಾಹಿತಿ ಲೇಖನಗಳು",
      blogsTitle1: "ನಮ್ಮ",
      blogsTitle2: "ಬ್ಲಾಗ್ಸ್",
      blogsSubtitle: "ಕೃಷಿ ಯಂತ್ರೋಪಕರಣಗಳು, ಆಹಾರ ಸಂಸ್ಕರಣಾ ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ನಿರ್ವಹಣೆಯ ಕುರಿತು ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್‌ನ ತಜ್ಞರ ಲೇಖನಗಳನ್ನು ಅನ್ವೇಷಿಸಿ.",
      searchArticles: "ಲೇಖನಗಳನ್ನು ಹುಡುಕಿ...",
      noArticlesFound: "ಯಾವುದೇ ಲೇಖನಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
      tryDifferentSearch: "ಬೇರೆ ಹುಡುಕಾಟ ಪದ ಅಥವಾ ವರ್ಗವನ್ನು ಪ್ರಯತ್ನಿಸಿ.",
      readArticle: "ಲೇಖನ ಓದಿ",
      backToAllArticles: "ಎಲ್ಲಾ ಲೇಖನಗಳಿಗೆ ಹಿಂತಿರುಗಿ",
      backToBlogs: "ಬ್ಲಾಗ್‌ಗಳಿಗೆ ಹಿಂತಿರುಗಿ",
      blogNotFound: "ಬ್ಲಾಗ್ ಪೋಸ್ಟ್ ಕಂಡುಬಂದಿಲ್ಲ.",

      // ─── FOOTER ───
      footerAboutDesc: "ಕಳೆದ ಮೂರು ದಶಕಗಳಿಂದ, ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಬಾಳಿಕೆ, ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಗುಣಮಟ್ಟದ ಕೃಷಿ ಮತ್ತು ಆಹಾರ ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ತಯಾರಿಸುತ್ತಿದೆ.",
      footerQuickLinks: "ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು",
      footerContactInfo: "ಸಂಪರ್ಕ ವಿವರಗಳು",
      footerOpeningHours: "ಕೆಲಸದ ಸಮಯ",
      footerMonSat: "ಸೋಮವಾರ - ಶನಿವಾರ:",
      footerTime: "ಬೆಳಿಗ್ಗೆ ೦೯.೦೦ ರಿಂದ ಸಂಜೆ ೦೬.೦೦",
      footerWeeklyOff: "ವಾರದ ರಜೆ: ಮಂಗಳವಾರ",
      footerRights: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
      footerDesignedBy: "ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ ಮತ್ತು ಅಭಿವೃದ್ಧಿಪಡಿಸಲಾಗಿದೆ"
    }
  }
};

const savedLang = localStorage.getItem('i18nextLng') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

const updateHtmlLanguageClass = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.classList.remove('lang-en', 'lang-mr', 'lang-kn');
    document.documentElement.classList.add(`lang-${lng}`);
    document.documentElement.lang = lng;
  }
};

updateHtmlLanguageClass(savedLang);

i18n.on('languageChanged', (lng) => {
  updateHtmlLanguageClass(lng);
});

export default i18n;
